/**
 * Exercise Image Asset Registry
 * 
 * React Native requires static require() paths for bundled assets.
 * This file creates a mapping from exercise IDs to their bundled images.
 * 
 * Auto-generated from 1500 webp files.
 */

const exerciseImages: Record<string, any> = {
  '01qpYSe': require('../../assets/exercise-gif/01qpYSe.gif'),
  '03lzqwk': require('../../assets/exercise-gif/03lzqwk.gif'),
  '05Cf2v8': require('../../assets/exercise-gif/05Cf2v8.gif'),
  '0CXGHya': require('../../assets/exercise-gif/0CXGHya.gif'),
  '0I5fUyn': require('../../assets/exercise-gif/0I5fUyn.gif'),
  '0IgNjSM': require('../../assets/exercise-gif/0IgNjSM.gif'),
  '0JtKWum': require('../../assets/exercise-gif/0JtKWum.gif'),
  '0L2KwtI': require('../../assets/exercise-gif/0L2KwtI.gif'),
  '0MlxeMn': require('../../assets/exercise-gif/0MlxeMn.gif'),
  '0S75mYG': require('../../assets/exercise-gif/0S75mYG.gif'),
  '0V2YQjW': require('../../assets/exercise-gif/0V2YQjW.gif'),
  '0Yz8WdV': require('../../assets/exercise-gif/0Yz8WdV.gif'),
  '0br45wL': require('../../assets/exercise-gif/0br45wL.gif'),
  '0dCyly0': require('../../assets/exercise-gif/0dCyly0.gif'),
  '0jp9Rlz': require('../../assets/exercise-gif/0jp9Rlz.gif'),
  '0lQnxMZ': require('../../assets/exercise-gif/0lQnxMZ.gif'),
  '0mB6wHO': require('../../assets/exercise-gif/0mB6wHO.gif'),
  '0rHfvy9': require('../../assets/exercise-gif/0rHfvy9.gif'),
  '0xDpB4L': require('../../assets/exercise-gif/0xDpB4L.gif'),
  '10Z2DXU': require('../../assets/exercise-gif/10Z2DXU.gif'),
  '11wrviz': require('../../assets/exercise-gif/11wrviz.gif'),
  '13TpY4H': require('../../assets/exercise-gif/13TpY4H.gif'),
  '13VW2VO': require('../../assets/exercise-gif/13VW2VO.gif'),
  '17bqEXD': require('../../assets/exercise-gif/17bqEXD.gif'),
  '17lJ1kr': require('../../assets/exercise-gif/17lJ1kr.gif'),
  '196HJGw': require('../../assets/exercise-gif/196HJGw.gif'),
  '1DN3iz4': require('../../assets/exercise-gif/1DN3iz4.gif'),
  '1GPHRyK': require('../../assets/exercise-gif/1GPHRyK.gif'),
  '1IFV9h3': require('../../assets/exercise-gif/1IFV9h3.gif'),
  '1IG6gVF': require('../../assets/exercise-gif/1IG6gVF.gif'),
  '1LVFcEn': require('../../assets/exercise-gif/1LVFcEn.gif'),
  '1PK5Uo3': require('../../assets/exercise-gif/1PK5Uo3.gif'),
  '1PLE8e9': require('../../assets/exercise-gif/1PLE8e9.gif'),
  '1RIkUHT': require('../../assets/exercise-gif/1RIkUHT.gif'),
  '1TVoin7': require('../../assets/exercise-gif/1TVoin7.gif'),
  '1TkiAFK': require('../../assets/exercise-gif/1TkiAFK.gif'),
  '1V1gj1u': require('../../assets/exercise-gif/1V1gj1u.gif'),
  '1VpF8db': require('../../assets/exercise-gif/1VpF8db.gif'),
  '1YB40kg': require('../../assets/exercise-gif/1YB40kg.gif'),
  '1YUWDNZ': require('../../assets/exercise-gif/1YUWDNZ.gif'),
  '1ZFqTDN': require('../../assets/exercise-gif/1ZFqTDN.gif'),
  '1bQkKZK': require('../../assets/exercise-gif/1bQkKZK.gif'),
  '1cTf2Ux': require('../../assets/exercise-gif/1cTf2Ux.gif'),
  '1g5bPpA': require('../../assets/exercise-gif/1g5bPpA.gif'),
  '1gFNTZV': require('../../assets/exercise-gif/1gFNTZV.gif'),
  '1jXLYEw': require('../../assets/exercise-gif/1jXLYEw.gif'),
  '1kB3Wmk': require('../../assets/exercise-gif/1kB3Wmk.gif'),
  '1oE78pm': require('../../assets/exercise-gif/1oE78pm.gif'),
  '1qrWgZ2': require('../../assets/exercise-gif/1qrWgZ2.gif'),
  '1u36hhy': require('../../assets/exercise-gif/1u36hhy.gif'),
  '1xHyxys': require('../../assets/exercise-gif/1xHyxys.gif'),
  '225x2Vd': require('../../assets/exercise-gif/225x2Vd.gif'),
  '25GPyDY': require('../../assets/exercise-gif/25GPyDY.gif'),
  '27NNGFr': require('../../assets/exercise-gif/27NNGFr.gif'),
  '2Dk4xQV': require('../../assets/exercise-gif/2Dk4xQV.gif'),
  '2DxtqHL': require('../../assets/exercise-gif/2DxtqHL.gif'),
  '2IHEa2T': require('../../assets/exercise-gif/2IHEa2T.gif'),
  '2IxROQ1': require('../../assets/exercise-gif/2IxROQ1.gif'),
  '2JCuFTU': require('../../assets/exercise-gif/2JCuFTU.gif'),
  '2KGnL6M': require('../../assets/exercise-gif/2KGnL6M.gif'),
  '2LQkNPW': require('../../assets/exercise-gif/2LQkNPW.gif'),
  '2NImIAG': require('../../assets/exercise-gif/2NImIAG.gif'),
  '2NpxjC1': require('../../assets/exercise-gif/2NpxjC1.gif'),
  '2ORFMoR': require('../../assets/exercise-gif/2ORFMoR.gif'),
  '2Pya1cP': require('../../assets/exercise-gif/2Pya1cP.gif'),
  '2Qh2J1e': require('../../assets/exercise-gif/2Qh2J1e.gif'),
  '2Ryn564': require('../../assets/exercise-gif/2Ryn564.gif'),
  '2Ty4idJ': require('../../assets/exercise-gif/2Ty4idJ.gif'),
  '2dImyQ8': require('../../assets/exercise-gif/2dImyQ8.gif'),
  '2gPfomN': require('../../assets/exercise-gif/2gPfomN.gif'),
  '2jl9K55': require('../../assets/exercise-gif/2jl9K55.gif'),
  '2kattbR': require('../../assets/exercise-gif/2kattbR.gif'),
  '2kr2lWy': require('../../assets/exercise-gif/2kr2lWy.gif'),
  '2qTvJAZ': require('../../assets/exercise-gif/2qTvJAZ.gif'),
  '2sQGZ5b': require('../../assets/exercise-gif/2sQGZ5b.gif'),
  '2zNKRUB': require('../../assets/exercise-gif/2zNKRUB.gif'),
  '33AzZeV': require('../../assets/exercise-gif/33AzZeV.gif'),
  '3QgteDK': require('../../assets/exercise-gif/3QgteDK.gif'),
  '3T12T87': require('../../assets/exercise-gif/3T12T87.gif'),
  '3TZduzM': require('../../assets/exercise-gif/3TZduzM.gif'),
  '3XFdb1Z': require('../../assets/exercise-gif/3XFdb1Z.gif'),
  '3ZflifB': require('../../assets/exercise-gif/3ZflifB.gif'),
  '3d7wHyd': require('../../assets/exercise-gif/3d7wHyd.gif'),
  '3eGE2JC': require('../../assets/exercise-gif/3eGE2JC.gif'),
  '3nvEbbF': require('../../assets/exercise-gif/3nvEbbF.gif'),
  '3omWx6P': require('../../assets/exercise-gif/3omWx6P.gif'),
  '3pqGMQj': require('../../assets/exercise-gif/3pqGMQj.gif'),
  '3s4NnTh': require('../../assets/exercise-gif/3s4NnTh.gif'),
  '3tAXPQ6': require('../../assets/exercise-gif/3tAXPQ6.gif'),
  '3uj0Ozg': require('../../assets/exercise-gif/3uj0Ozg.gif'),
  '3xK09Sk': require('../../assets/exercise-gif/3xK09Sk.gif'),
  '4CBIBOM': require('../../assets/exercise-gif/4CBIBOM.gif'),
  '4GqRrAk': require('../../assets/exercise-gif/4GqRrAk.gif'),
  '4H86mXM': require('../../assets/exercise-gif/4H86mXM.gif'),
  '4IKbhHV': require('../../assets/exercise-gif/4IKbhHV.gif'),
  '4Jc36XM': require('../../assets/exercise-gif/4Jc36XM.gif'),
  '4Jt8QsQ': require('../../assets/exercise-gif/4Jt8QsQ.gif'),
  '4KJEpzb': require('../../assets/exercise-gif/4KJEpzb.gif'),
  '4LIG9xr': require('../../assets/exercise-gif/4LIG9xr.gif'),
  '4Leypho': require('../../assets/exercise-gif/4Leypho.gif'),
  '4LoWllp': require('../../assets/exercise-gif/4LoWllp.gif'),
  '4Ml7QFO': require('../../assets/exercise-gif/4Ml7QFO.gif'),
  '4OaumBr': require('../../assets/exercise-gif/4OaumBr.gif'),
  '4QqYaJW': require('../../assets/exercise-gif/4QqYaJW.gif'),
  '4U7iLb5': require('../../assets/exercise-gif/4U7iLb5.gif'),
  '4c9BhzB': require('../../assets/exercise-gif/4c9BhzB.gif'),
  '4cWjYEN': require('../../assets/exercise-gif/4cWjYEN.gif'),
  '4dF3maG': require('../../assets/exercise-gif/4dF3maG.gif'),
  '4dUn2iv': require('../../assets/exercise-gif/4dUn2iv.gif'),
  '4f8RXP8': require('../../assets/exercise-gif/4f8RXP8.gif'),
  '4hATdoB': require('../../assets/exercise-gif/4hATdoB.gif'),
  '4ievMJ9': require('../../assets/exercise-gif/4ievMJ9.gif'),
  '4x5Okof': require('../../assets/exercise-gif/4x5Okof.gif'),
  '50BETrz': require('../../assets/exercise-gif/50BETrz.gif'),
  '53Ttlck': require('../../assets/exercise-gif/53Ttlck.gif'),
  '58rdhvL': require('../../assets/exercise-gif/58rdhvL.gif'),
  '5BZHW9s': require('../../assets/exercise-gif/5BZHW9s.gif'),
  '5KLbZWx': require('../../assets/exercise-gif/5KLbZWx.gif'),
  '5MRH8H2': require('../../assets/exercise-gif/5MRH8H2.gif'),
  '5VCj6iH': require('../../assets/exercise-gif/5VCj6iH.gif'),
  '5VXmnV5': require('../../assets/exercise-gif/5VXmnV5.gif'),
  '5WiFcYk': require('../../assets/exercise-gif/5WiFcYk.gif'),
  '5bpPTHv': require('../../assets/exercise-gif/5bpPTHv.gif'),
  '5eLRITT': require('../../assets/exercise-gif/5eLRITT.gif'),
  '5fKX7wi': require('../../assets/exercise-gif/5fKX7wi.gif'),
  '5ipN0iE': require('../../assets/exercise-gif/5ipN0iE.gif'),
  '5lE7XRz': require('../../assets/exercise-gif/5lE7XRz.gif'),
  '5uFK1xr': require('../../assets/exercise-gif/5uFK1xr.gif'),
  '5v7KYld': require('../../assets/exercise-gif/5v7KYld.gif'),
  '5vfAI0I': require('../../assets/exercise-gif/5vfAI0I.gif'),
  '61GrD55': require('../../assets/exercise-gif/61GrD55.gif'),
  '62Nw60O': require('../../assets/exercise-gif/62Nw60O.gif'),
  '641mIfk': require('../../assets/exercise-gif/641mIfk.gif'),
  '67n3r98': require('../../assets/exercise-gif/67n3r98.gif'),
  '6CKUx7o': require('../../assets/exercise-gif/6CKUx7o.gif'),
  '6FMU51h': require('../../assets/exercise-gif/6FMU51h.gif'),
  '6HiHHe0': require('../../assets/exercise-gif/6HiHHe0.gif'),
  '6HmFgmx': require('../../assets/exercise-gif/6HmFgmx.gif'),
  '6MaEjVA': require('../../assets/exercise-gif/6MaEjVA.gif'),
  '6MfS53i': require('../../assets/exercise-gif/6MfS53i.gif'),
  '6TG6x2w': require('../../assets/exercise-gif/6TG6x2w.gif'),
  '6Wr0F3W': require('../../assets/exercise-gif/6Wr0F3W.gif'),
  '6YUfHPL': require('../../assets/exercise-gif/6YUfHPL.gif'),
  '6ZCiYWQ': require('../../assets/exercise-gif/6ZCiYWQ.gif'),
  '6bOA1Oi': require('../../assets/exercise-gif/6bOA1Oi.gif'),
  '6cKQC5E': require('../../assets/exercise-gif/6cKQC5E.gif'),
  '6e2DcYX': require('../../assets/exercise-gif/6e2DcYX.gif'),
  '6em2Dxj': require('../../assets/exercise-gif/6em2Dxj.gif'),
  '6kSxYnw': require('../../assets/exercise-gif/6kSxYnw.gif'),
  '6pTkI99': require('../../assets/exercise-gif/6pTkI99.gif'),
  '6sMAmNv': require('../../assets/exercise-gif/6sMAmNv.gif'),
  '6sYyrRX': require('../../assets/exercise-gif/6sYyrRX.gif'),
  '6t00BsF': require('../../assets/exercise-gif/6t00BsF.gif'),
  '6vcvsLS': require('../../assets/exercise-gif/6vcvsLS.gif'),
  '72BC5Za': require('../../assets/exercise-gif/72BC5Za.gif'),
  '75Bgtjy': require('../../assets/exercise-gif/75Bgtjy.gif'),
  '76vfTdU': require('../../assets/exercise-gif/76vfTdU.gif'),
  '7858za8': require('../../assets/exercise-gif/7858za8.gif'),
  '78VqWQK': require('../../assets/exercise-gif/78VqWQK.gif'),
  '79AmJsI': require('../../assets/exercise-gif/79AmJsI.gif'),
  '7AnZtSv': require('../../assets/exercise-gif/7AnZtSv.gif'),
  '7B4F5nZ': require('../../assets/exercise-gif/7B4F5nZ.gif'),
  '7Ba7bQ2': require('../../assets/exercise-gif/7Ba7bQ2.gif'),
  '7D5bgLT': require('../../assets/exercise-gif/7D5bgLT.gif'),
  '7E06s6d': require('../../assets/exercise-gif/7E06s6d.gif'),
  '7F1DVzn': require('../../assets/exercise-gif/7F1DVzn.gif'),
  '7HcfMBP': require('../../assets/exercise-gif/7HcfMBP.gif'),
  '7Hg55JG': require('../../assets/exercise-gif/7Hg55JG.gif'),
  '7I6LNUG': require('../../assets/exercise-gif/7I6LNUG.gif'),
  '7M66AVi': require('../../assets/exercise-gif/7M66AVi.gif'),
  '7OeHptV': require('../../assets/exercise-gif/7OeHptV.gif'),
  '7R4NIjL': require('../../assets/exercise-gif/7R4NIjL.gif'),
  '7RWNjiB': require('../../assets/exercise-gif/7RWNjiB.gif'),
  '7WaDzyL': require('../../assets/exercise-gif/7WaDzyL.gif'),
  '7WcQgkm': require('../../assets/exercise-gif/7WcQgkm.gif'),
  '7aVz15j': require('../../assets/exercise-gif/7aVz15j.gif'),
  '7aolH9D': require('../../assets/exercise-gif/7aolH9D.gif'),
  '7ePTw4B': require('../../assets/exercise-gif/7ePTw4B.gif'),
  '7f2jsqP': require('../../assets/exercise-gif/7f2jsqP.gif'),
  '7gdLIXa': require('../../assets/exercise-gif/7gdLIXa.gif'),
  '7i4msxz': require('../../assets/exercise-gif/7i4msxz.gif'),
  '7inpWch': require('../../assets/exercise-gif/7inpWch.gif'),
  '7jGOBF3': require('../../assets/exercise-gif/7jGOBF3.gif'),
  '7saC5zz': require('../../assets/exercise-gif/7saC5zz.gif'),
  '7uFJuXp': require('../../assets/exercise-gif/7uFJuXp.gif'),
  '7vG5o25': require('../../assets/exercise-gif/7vG5o25.gif'),
  '7w6i0vE': require('../../assets/exercise-gif/7w6i0vE.gif'),
  '7xI5MXA': require('../../assets/exercise-gif/7xI5MXA.gif'),
  '7xeukSt': require('../../assets/exercise-gif/7xeukSt.gif'),
  '7y9JIMj': require('../../assets/exercise-gif/7y9JIMj.gif'),
  '7zdxRTl': require('../../assets/exercise-gif/7zdxRTl.gif'),
  '82LxxkW': require('../../assets/exercise-gif/82LxxkW.gif'),
  '83HoW9X': require('../../assets/exercise-gif/83HoW9X.gif'),
  '84RyJf8': require('../../assets/exercise-gif/84RyJf8.gif'),
  '84sESNy': require('../../assets/exercise-gif/84sESNy.gif'),
  '89HVjEp': require('../../assets/exercise-gif/89HVjEp.gif'),
  '8ARQ9Hw': require('../../assets/exercise-gif/8ARQ9Hw.gif'),
  '8DiFDVA': require('../../assets/exercise-gif/8DiFDVA.gif'),
  '8IbNZwc': require('../../assets/exercise-gif/8IbNZwc.gif'),
  '8K0w2yA': require('../../assets/exercise-gif/8K0w2yA.gif'),
  '8K7m2SS': require('../../assets/exercise-gif/8K7m2SS.gif'),
  '8coXSYU': require('../../assets/exercise-gif/8coXSYU.gif'),
  '8d8qJQI': require('../../assets/exercise-gif/8d8qJQI.gif'),
  '8eqjhOl': require('../../assets/exercise-gif/8eqjhOl.gif'),
  '8fgqP5a': require('../../assets/exercise-gif/8fgqP5a.gif'),
  '8gQo5Ss': require('../../assets/exercise-gif/8gQo5Ss.gif'),
  '8oYqOt9': require('../../assets/exercise-gif/8oYqOt9.gif'),
  '8ozhUIZ': require('../../assets/exercise-gif/8ozhUIZ.gif'),
  '8urJS9b': require('../../assets/exercise-gif/8urJS9b.gif'),
  '8xUv4J7': require('../../assets/exercise-gif/8xUv4J7.gif'),
  '8yBgwBS': require('../../assets/exercise-gif/8yBgwBS.gif'),
  '903mzG8': require('../../assets/exercise-gif/903mzG8.gif'),
  '945zpRg': require('../../assets/exercise-gif/945zpRg.gif'),
  '99rWm7w': require('../../assets/exercise-gif/99rWm7w.gif'),
  '9Ap7miY': require('../../assets/exercise-gif/9Ap7miY.gif'),
  '9E25EOx': require('../../assets/exercise-gif/9E25EOx.gif'),
  '9GXrTE6': require('../../assets/exercise-gif/9GXrTE6.gif'),
  '9IxJdtC': require('../../assets/exercise-gif/9IxJdtC.gif'),
  '9JprnPh': require('../../assets/exercise-gif/9JprnPh.gif'),
  '9KU9TYF': require('../../assets/exercise-gif/9KU9TYF.gif'),
  '9RT8oQW': require('../../assets/exercise-gif/9RT8oQW.gif'),
  '9Tkqa9O': require('../../assets/exercise-gif/9Tkqa9O.gif'),
  '9WTm7dq': require('../../assets/exercise-gif/9WTm7dq.gif'),
  '9XjtHvS': require('../../assets/exercise-gif/9XjtHvS.gif'),
  '9Z23cLE': require('../../assets/exercise-gif/9Z23cLE.gif'),
  '9ZGZuOD': require('../../assets/exercise-gif/9ZGZuOD.gif'),
  '9ZGnq1w': require('../../assets/exercise-gif/9ZGnq1w.gif'),
  '9c6T1YX': require('../../assets/exercise-gif/9c6T1YX.gif'),
  '9fCHfSc': require('../../assets/exercise-gif/9fCHfSc.gif'),
  '9gbyYKk': require('../../assets/exercise-gif/9gbyYKk.gif'),
  '9n2149Z': require('../../assets/exercise-gif/9n2149Z.gif'),
  '9pQSkH8': require('../../assets/exercise-gif/9pQSkH8.gif'),
  '9pa4H5m': require('../../assets/exercise-gif/9pa4H5m.gif'),
  '9sgNE2O': require('../../assets/exercise-gif/9sgNE2O.gif'),
  '9tvVVM9': require('../../assets/exercise-gif/9tvVVM9.gif'),
  '9vz4JlC': require('../../assets/exercise-gif/9vz4JlC.gif'),
  'A2upspL': require('../../assets/exercise-gif/A2upspL.gif'),
  'A3P4O0R': require('../../assets/exercise-gif/A3P4O0R.gif'),
  'A6wtbuL': require('../../assets/exercise-gif/A6wtbuL.gif'),
  'A9qxk2F': require('../../assets/exercise-gif/A9qxk2F.gif'),
  'ANbbry2': require('../../assets/exercise-gif/ANbbry2.gif'),
  'AQ0mC4Y': require('../../assets/exercise-gif/AQ0mC4Y.gif'),
  'AQIhRjM': require('../../assets/exercise-gif/AQIhRjM.gif'),
  'AR0ig3o': require('../../assets/exercise-gif/AR0ig3o.gif'),
  'AX1kB0o': require('../../assets/exercise-gif/AX1kB0o.gif'),
  'AdxxqfF': require('../../assets/exercise-gif/AdxxqfF.gif'),
  'Af0EW2I': require('../../assets/exercise-gif/Af0EW2I.gif'),
  'Aj9vWh7': require('../../assets/exercise-gif/Aj9vWh7.gif'),
  'Al3tP0D': require('../../assets/exercise-gif/Al3tP0D.gif'),
  'Am02iPd': require('../../assets/exercise-gif/Am02iPd.gif'),
  'AwAIlSo': require('../../assets/exercise-gif/AwAIlSo.gif'),
  'AxFoqAD': require('../../assets/exercise-gif/AxFoqAD.gif'),
  'B1EVP9F': require('../../assets/exercise-gif/B1EVP9F.gif'),
  'B3Rxp6L': require('../../assets/exercise-gif/B3Rxp6L.gif'),
  'B5xca8s': require('../../assets/exercise-gif/B5xca8s.gif'),
  'B6dAO1t': require('../../assets/exercise-gif/B6dAO1t.gif'),
  'BCGQ6J5': require('../../assets/exercise-gif/BCGQ6J5.gif'),
  'BCUR88E': require('../../assets/exercise-gif/BCUR88E.gif'),
  'BCs0G2F': require('../../assets/exercise-gif/BCs0G2F.gif'),
  'BIb1tGo': require('../../assets/exercise-gif/BIb1tGo.gif'),
  'BJ0Hz5L': require('../../assets/exercise-gif/BJ0Hz5L.gif'),
  'BKa8dmT': require('../../assets/exercise-gif/BKa8dmT.gif'),
  'BL3GHeY': require('../../assets/exercise-gif/BL3GHeY.gif'),
  'BLCvwr2': require('../../assets/exercise-gif/BLCvwr2.gif'),
  'BMMolZ3': require('../../assets/exercise-gif/BMMolZ3.gif'),
  'BRImeP8': require('../../assets/exercise-gif/BRImeP8.gif'),
  'BReCuOn': require('../../assets/exercise-gif/BReCuOn.gif'),
  'BU15nH4': require('../../assets/exercise-gif/BU15nH4.gif'),
  'BWnJR72': require('../../assets/exercise-gif/BWnJR72.gif'),
  'BaE7O6U': require('../../assets/exercise-gif/BaE7O6U.gif'),
  'BbfB8Gb': require('../../assets/exercise-gif/BbfB8Gb.gif'),
  'BeReYBf': require('../../assets/exercise-gif/BeReYBf.gif'),
  'Bg5JKSH': require('../../assets/exercise-gif/Bg5JKSH.gif'),
  'BgljGjd': require('../../assets/exercise-gif/BgljGjd.gif'),
  'BkxB8LW': require('../../assets/exercise-gif/BkxB8LW.gif'),
  'BmrwWzo': require('../../assets/exercise-gif/BmrwWzo.gif'),
  'Bn6TXyO': require('../../assets/exercise-gif/Bn6TXyO.gif'),
  'Bpkf41o': require('../../assets/exercise-gif/Bpkf41o.gif'),
  'BqgCRif': require('../../assets/exercise-gif/BqgCRif.gif'),
  'BwSNDGt': require('../../assets/exercise-gif/BwSNDGt.gif'),
  'ByX0WxV': require('../../assets/exercise-gif/ByX0WxV.gif'),
  'C0MA9bC': require('../../assets/exercise-gif/C0MA9bC.gif'),
  'C0eCeEt': require('../../assets/exercise-gif/C0eCeEt.gif'),
  'C31LMnP': require('../../assets/exercise-gif/C31LMnP.gif'),
  'C5jncD2': require('../../assets/exercise-gif/C5jncD2.gif'),
  'C8Crfa4': require('../../assets/exercise-gif/C8Crfa4.gif'),
  'C9LuR4A': require('../../assets/exercise-gif/C9LuR4A.gif'),
  'CB8WET1': require('../../assets/exercise-gif/CB8WET1.gif'),
  'CFN9P8G': require('../../assets/exercise-gif/CFN9P8G.gif'),
  'CHpahtl': require('../../assets/exercise-gif/CHpahtl.gif'),
  'CI6baTY': require('../../assets/exercise-gif/CI6baTY.gif'),
  'CJwa0vD': require('../../assets/exercise-gif/CJwa0vD.gif'),
  'CMAxnsG': require('../../assets/exercise-gif/CMAxnsG.gif'),
  'CQHoDm0': require('../../assets/exercise-gif/CQHoDm0.gif'),
  'CUmLRTA': require('../../assets/exercise-gif/CUmLRTA.gif'),
  'Ca76jUE': require('../../assets/exercise-gif/Ca76jUE.gif'),
  'CbFSYC1': require('../../assets/exercise-gif/CbFSYC1.gif'),
  'CcWEoWV': require('../../assets/exercise-gif/CcWEoWV.gif'),
  'CfKsRbG': require('../../assets/exercise-gif/CfKsRbG.gif'),
  'CggQhII': require('../../assets/exercise-gif/CggQhII.gif'),
  'CjETvlw': require('../../assets/exercise-gif/CjETvlw.gif'),
  'CmEr4pM': require('../../assets/exercise-gif/CmEr4pM.gif'),
  'CosupLu': require('../../assets/exercise-gif/CosupLu.gif'),
  'CqhoytW': require('../../assets/exercise-gif/CqhoytW.gif'),
  'CuaWCmC': require('../../assets/exercise-gif/CuaWCmC.gif'),
  'CvPn9WV': require('../../assets/exercise-gif/CvPn9WV.gif'),
  'D1xYJAU': require('../../assets/exercise-gif/D1xYJAU.gif'),
  'D5yqP2p': require('../../assets/exercise-gif/D5yqP2p.gif'),
  'D9qe7CM': require('../../assets/exercise-gif/D9qe7CM.gif'),
  'DB0n8AG': require('../../assets/exercise-gif/DB0n8AG.gif'),
  'DEEqoI2': require('../../assets/exercise-gif/DEEqoI2.gif'),
  'DFGXwZr': require('../../assets/exercise-gif/DFGXwZr.gif'),
  'DICPHtq': require('../../assets/exercise-gif/DICPHtq.gif'),
  'DIVyqrU': require('../../assets/exercise-gif/DIVyqrU.gif'),
  'DKBwJrL': require('../../assets/exercise-gif/DKBwJrL.gif'),
  'DOoWcnA': require('../../assets/exercise-gif/DOoWcnA.gif'),
  'DQ0cqkT': require('../../assets/exercise-gif/DQ0cqkT.gif'),
  'DT14T9T': require('../../assets/exercise-gif/DT14T9T.gif'),
  'DU5Kkj2': require('../../assets/exercise-gif/DU5Kkj2.gif'),
  'DU7I633': require('../../assets/exercise-gif/DU7I633.gif'),
  'Db7eEgw': require('../../assets/exercise-gif/Db7eEgw.gif'),
  'DeDThfG': require('../../assets/exercise-gif/DeDThfG.gif'),
  'DgZQ11d': require('../../assets/exercise-gif/DgZQ11d.gif'),
  'DhMl549': require('../../assets/exercise-gif/DhMl549.gif'),
  'DoEYq4s': require('../../assets/exercise-gif/DoEYq4s.gif'),
  'DotAgEF': require('../../assets/exercise-gif/DotAgEF.gif'),
  'DpWMFP5': require('../../assets/exercise-gif/DpWMFP5.gif'),
  'DptumMx': require('../../assets/exercise-gif/DptumMx.gif'),
  'Dsfz0Id': require('../../assets/exercise-gif/Dsfz0Id.gif'),
  'DsgkuIt': require('../../assets/exercise-gif/DsgkuIt.gif'),
  'DwhEmmE': require('../../assets/exercise-gif/DwhEmmE.gif'),
  'Dx2RIva': require('../../assets/exercise-gif/Dx2RIva.gif'),
  'E4PwJqI': require('../../assets/exercise-gif/E4PwJqI.gif'),
  'E4R8Hz1': require('../../assets/exercise-gif/E4R8Hz1.gif'),
  'EAs3xL9': require('../../assets/exercise-gif/EAs3xL9.gif'),
  'EIeI8Vf': require('../../assets/exercise-gif/EIeI8Vf.gif'),
  'EIsE3u8': require('../../assets/exercise-gif/EIsE3u8.gif'),
  'EKXOMEh': require('../../assets/exercise-gif/EKXOMEh.gif'),
  'EMpUwRI': require('../../assets/exercise-gif/EMpUwRI.gif'),
  'ESOd5Pl': require('../../assets/exercise-gif/ESOd5Pl.gif'),
  'ETZfAbZ': require('../../assets/exercise-gif/ETZfAbZ.gif'),
  'EZeDVzO': require('../../assets/exercise-gif/EZeDVzO.gif'),
  'EcaV7aL': require('../../assets/exercise-gif/EcaV7aL.gif'),
  'Eg98Ft9': require('../../assets/exercise-gif/Eg98Ft9.gif'),
  'Eh2v5Iu': require('../../assets/exercise-gif/Eh2v5Iu.gif'),
  'EmlJR2y': require('../../assets/exercise-gif/EmlJR2y.gif'),
  'EnPivTL': require('../../assets/exercise-gif/EnPivTL.gif'),
  'EpKrFiv': require('../../assets/exercise-gif/EpKrFiv.gif'),
  'EqHIIjJ': require('../../assets/exercise-gif/EqHIIjJ.gif'),
  'ErqK3UL': require('../../assets/exercise-gif/ErqK3UL.gif'),
  'EyLrNC2': require('../../assets/exercise-gif/EyLrNC2.gif'),
  'Ezpnw9d': require('../../assets/exercise-gif/Ezpnw9d.gif'),
  'F1KxjBa': require('../../assets/exercise-gif/F1KxjBa.gif'),
  'F3xgbjF': require('../../assets/exercise-gif/F3xgbjF.gif'),
  'F56Xpw3': require('../../assets/exercise-gif/F56Xpw3.gif'),
  'F7vjXqT': require('../../assets/exercise-gif/F7vjXqT.gif'),
  'FAoIFMw': require('../../assets/exercise-gif/FAoIFMw.gif'),
  'FFRP97T': require('../../assets/exercise-gif/FFRP97T.gif'),
  'FQXdXzY': require('../../assets/exercise-gif/FQXdXzY.gif'),
  'FS63wTN': require('../../assets/exercise-gif/FS63wTN.gif'),
  'FSD6PGL': require('../../assets/exercise-gif/FSD6PGL.gif'),
  'FSF9WOs': require('../../assets/exercise-gif/FSF9WOs.gif'),
  'FVM1AUZ': require('../../assets/exercise-gif/FVM1AUZ.gif'),
  'FVmZVhk': require('../../assets/exercise-gif/FVmZVhk.gif'),
  'FWdVhcW': require('../../assets/exercise-gif/FWdVhcW.gif'),
  'FY3UdNT': require('../../assets/exercise-gif/FY3UdNT.gif'),
  'Ff18ItA': require('../../assets/exercise-gif/Ff18ItA.gif'),
  'Fhdtwf3': require('../../assets/exercise-gif/Fhdtwf3.gif'),
  'FkBIE6a': require('../../assets/exercise-gif/FkBIE6a.gif'),
  'FxhcxUW': require('../../assets/exercise-gif/FxhcxUW.gif'),
  'G08RZcQ': require('../../assets/exercise-gif/G08RZcQ.gif'),
  'G1qWW6M': require('../../assets/exercise-gif/G1qWW6M.gif'),
  'G61cXLk': require('../../assets/exercise-gif/G61cXLk.gif'),
  'G70mEAJ': require('../../assets/exercise-gif/G70mEAJ.gif'),
  'G7PXMlT': require('../../assets/exercise-gif/G7PXMlT.gif'),
  'G7xoEzr': require('../../assets/exercise-gif/G7xoEzr.gif'),
  'G8dXpNG': require('../../assets/exercise-gif/G8dXpNG.gif'),
  'GKEH6jj': require('../../assets/exercise-gif/GKEH6jj.gif'),
  'GNhAeJ0': require('../../assets/exercise-gif/GNhAeJ0.gif'),
  'GOJKFfO': require('../../assets/exercise-gif/GOJKFfO.gif'),
  'GSDioYu': require('../../assets/exercise-gif/GSDioYu.gif'),
  'GUT8I22': require('../../assets/exercise-gif/GUT8I22.gif'),
  'GWoKnIm': require('../../assets/exercise-gif/GWoKnIm.gif'),
  'GXoaSgn': require('../../assets/exercise-gif/GXoaSgn.gif'),
  'GaSzzuh': require('../../assets/exercise-gif/GaSzzuh.gif'),
  'Gchi5Tr': require('../../assets/exercise-gif/Gchi5Tr.gif'),
  'GdMa1ET': require('../../assets/exercise-gif/GdMa1ET.gif'),
  'Gi2BXfK': require('../../assets/exercise-gif/Gi2BXfK.gif'),
  'GibBPPg': require('../../assets/exercise-gif/GibBPPg.gif'),
  'Gk1r408': require('../../assets/exercise-gif/Gk1r408.gif'),
  'Gm2Uv1z': require('../../assets/exercise-gif/Gm2Uv1z.gif'),
  'Gn5FwYT': require('../../assets/exercise-gif/Gn5FwYT.gif'),
  'Gnfo4FM': require('../../assets/exercise-gif/Gnfo4FM.gif'),
  'Gpn4ADc': require('../../assets/exercise-gif/Gpn4ADc.gif'),
  'GrO65fd': require('../../assets/exercise-gif/GrO65fd.gif'),
  'Gu2ENkm': require('../../assets/exercise-gif/Gu2ENkm.gif'),
  'Gu2rNJd': require('../../assets/exercise-gif/Gu2rNJd.gif'),
  'Gw2HFvW': require('../../assets/exercise-gif/Gw2HFvW.gif'),
  'GwYwElT': require('../../assets/exercise-gif/GwYwElT.gif'),
  'GxDwDX0': require('../../assets/exercise-gif/GxDwDX0.gif'),
  'Gxg9lDc': require('../../assets/exercise-gif/Gxg9lDc.gif'),
  'H1PESYI': require('../../assets/exercise-gif/H1PESYI.gif'),
  'H1XAdpk': require('../../assets/exercise-gif/H1XAdpk.gif'),
  'H6ETwO9': require('../../assets/exercise-gif/H6ETwO9.gif'),
  'H6ybluc': require('../../assets/exercise-gif/H6ybluc.gif'),
  'H9y3Dkr': require('../../assets/exercise-gif/H9y3Dkr.gif'),
  'HBYyX94': require('../../assets/exercise-gif/HBYyX94.gif'),
  'HDYiZcY': require('../../assets/exercise-gif/HDYiZcY.gif'),
  'HEJ6DIX': require('../../assets/exercise-gif/HEJ6DIX.gif'),
  'HIgYKAB': require('../../assets/exercise-gif/HIgYKAB.gif'),
  'HJ63mSO': require('../../assets/exercise-gif/HJ63mSO.gif'),
  'HMzLjXx': require('../../assets/exercise-gif/HMzLjXx.gif'),
  'HPlPoQA': require('../../assets/exercise-gif/HPlPoQA.gif'),
  'HUEqZ1y': require('../../assets/exercise-gif/HUEqZ1y.gif'),
  'HYe1ZqR': require('../../assets/exercise-gif/HYe1ZqR.gif'),
  'HZgQPxh': require('../../assets/exercise-gif/HZgQPxh.gif'),
  'Ha7SZ3y': require('../../assets/exercise-gif/Ha7SZ3y.gif'),
  'HbSG1Pw': require('../../assets/exercise-gif/HbSG1Pw.gif'),
  'HfqciZF': require('../../assets/exercise-gif/HfqciZF.gif'),
  'Hgs6Nl1': require('../../assets/exercise-gif/Hgs6Nl1.gif'),
  'Hj4FOCd': require('../../assets/exercise-gif/Hj4FOCd.gif'),
  'HjdqmZa': require('../../assets/exercise-gif/HjdqmZa.gif'),
  'HsjbB1z': require('../../assets/exercise-gif/HsjbB1z.gif'),
  'HsvHqgf': require('../../assets/exercise-gif/HsvHqgf.gif'),
  'HtfCpfi': require('../../assets/exercise-gif/HtfCpfi.gif'),
  'Hx1WC8I': require('../../assets/exercise-gif/Hx1WC8I.gif'),
  'Hy9D21L': require('../../assets/exercise-gif/Hy9D21L.gif'),
  'I1OBLnn': require('../../assets/exercise-gif/I1OBLnn.gif'),
  'I3tsCnC': require('../../assets/exercise-gif/I3tsCnC.gif'),
  'I4KkPdl': require('../../assets/exercise-gif/I4KkPdl.gif'),
  'I4hDWkc': require('../../assets/exercise-gif/I4hDWkc.gif'),
  'I4tibZG': require('../../assets/exercise-gif/I4tibZG.gif'),
  'I6Ca0a7': require('../../assets/exercise-gif/I6Ca0a7.gif'),
  'IBj3nsn': require('../../assets/exercise-gif/IBj3nsn.gif'),
  'IENzBdA': require('../../assets/exercise-gif/IENzBdA.gif'),
  'IGjKj1v': require('../../assets/exercise-gif/IGjKj1v.gif'),
  'IGtBdNT': require('../../assets/exercise-gif/IGtBdNT.gif'),
  'IH2kr7n': require('../../assets/exercise-gif/IH2kr7n.gif'),
  'IL0JUxR': require('../../assets/exercise-gif/IL0JUxR.gif'),
  'IMRsOCn': require('../../assets/exercise-gif/IMRsOCn.gif'),
  'IU4QNJ6': require('../../assets/exercise-gif/IU4QNJ6.gif'),
  'IZVHb27': require('../../assets/exercise-gif/IZVHb27.gif'),
  'Ia7tumC': require('../../assets/exercise-gif/Ia7tumC.gif'),
  'IaGQCrC': require('../../assets/exercise-gif/IaGQCrC.gif'),
  'Ie9UGty': require('../../assets/exercise-gif/Ie9UGty.gif'),
  'IeDEXTe': require('../../assets/exercise-gif/IeDEXTe.gif'),
  'IeTIEqg': require('../../assets/exercise-gif/IeTIEqg.gif'),
  'Ion0XWz': require('../../assets/exercise-gif/Ion0XWz.gif'),
  'IpONWYv': require('../../assets/exercise-gif/IpONWYv.gif'),
  'Iptlv6x': require('../../assets/exercise-gif/Iptlv6x.gif'),
  'IvV6C9M': require('../../assets/exercise-gif/IvV6C9M.gif'),
  'IwX5NqK': require('../../assets/exercise-gif/IwX5NqK.gif'),
  'IxsFgRT': require('../../assets/exercise-gif/IxsFgRT.gif'),
  'J1vH2X0': require('../../assets/exercise-gif/J1vH2X0.gif'),
  'J60bN17': require('../../assets/exercise-gif/J60bN17.gif'),
  'J6Dx1Mu': require('../../assets/exercise-gif/J6Dx1Mu.gif'),
  'J74XlNf': require('../../assets/exercise-gif/J74XlNf.gif'),
  'J9zIWig': require('../../assets/exercise-gif/J9zIWig.gif'),
  'JF8AkMX': require('../../assets/exercise-gif/JF8AkMX.gif'),
  'JGKowMS': require('../../assets/exercise-gif/JGKowMS.gif'),
  'JOZhu2h': require('../../assets/exercise-gif/JOZhu2h.gif'),
  'JWjujiY': require('../../assets/exercise-gif/JWjujiY.gif'),
  'JZuApnB': require('../../assets/exercise-gif/JZuApnB.gif'),
  'JbC2iaV': require('../../assets/exercise-gif/JbC2iaV.gif'),
  'JhYSVwT': require('../../assets/exercise-gif/JhYSVwT.gif'),
  'JmMVpR3': require('../../assets/exercise-gif/JmMVpR3.gif'),
  'JrOHAZc': require('../../assets/exercise-gif/JrOHAZc.gif'),
  'JsKq9so': require('../../assets/exercise-gif/JsKq9so.gif'),
  'JsOV1SU': require('../../assets/exercise-gif/JsOV1SU.gif'),
  'Jsgsc27': require('../../assets/exercise-gif/Jsgsc27.gif'),
  'JxrY9mC': require('../../assets/exercise-gif/JxrY9mC.gif'),
  'JymLInS': require('../../assets/exercise-gif/JymLInS.gif'),
  'JzQbv7J': require('../../assets/exercise-gif/JzQbv7J.gif'),
  'K1vlode': require('../../assets/exercise-gif/K1vlode.gif'),
  'K3dIO25': require('../../assets/exercise-gif/K3dIO25.gif'),
  'K5xgdvI': require('../../assets/exercise-gif/K5xgdvI.gif'),
  'K9VL0Jq': require('../../assets/exercise-gif/K9VL0Jq.gif'),
  'KCBKjma': require('../../assets/exercise-gif/KCBKjma.gif'),
  'KHGNa16': require('../../assets/exercise-gif/KHGNa16.gif'),
  'KHPZL0b': require('../../assets/exercise-gif/KHPZL0b.gif'),
  'KI1DjNN': require('../../assets/exercise-gif/KI1DjNN.gif'),
  'KOpzGBL': require('../../assets/exercise-gif/KOpzGBL.gif'),
  'KQfySvS': require('../../assets/exercise-gif/KQfySvS.gif'),
  'KUaZst7': require('../../assets/exercise-gif/KUaZst7.gif'),
  'KUaoUV8': require('../../assets/exercise-gif/KUaoUV8.gif'),
  'KWdF2JI': require('../../assets/exercise-gif/KWdF2JI.gif'),
  'KWyEjtI': require('../../assets/exercise-gif/KWyEjtI.gif'),
  'KXyoEtA': require('../../assets/exercise-gif/KXyoEtA.gif'),
  'KZXAtKQ': require('../../assets/exercise-gif/KZXAtKQ.gif'),
  'KZn52RC': require('../../assets/exercise-gif/KZn52RC.gif'),
  'Kal9cQQ': require('../../assets/exercise-gif/Kal9cQQ.gif'),
  'KenZJQV': require('../../assets/exercise-gif/KenZJQV.gif'),
  'KgI0tqW': require('../../assets/exercise-gif/KgI0tqW.gif'),
  'KhHJ338': require('../../assets/exercise-gif/KhHJ338.gif'),
  'Kpajagk': require('../../assets/exercise-gif/Kpajagk.gif'),
  'Krmb3cB': require('../../assets/exercise-gif/Krmb3cB.gif'),
  'KtRomty': require('../../assets/exercise-gif/KtRomty.gif'),
  'KwFGiEP': require('../../assets/exercise-gif/KwFGiEP.gif'),
  'Kxquu2E': require('../../assets/exercise-gif/Kxquu2E.gif'),
  'KyLtiLT': require('../../assets/exercise-gif/KyLtiLT.gif'),
  'Kyd9Rz5': require('../../assets/exercise-gif/Kyd9Rz5.gif'),
  'Kzg30R7': require('../../assets/exercise-gif/Kzg30R7.gif'),
  'L2V5Nan': require('../../assets/exercise-gif/L2V5Nan.gif'),
  'L4ay0PW': require('../../assets/exercise-gif/L4ay0PW.gif'),
  'L68dTQj': require('../../assets/exercise-gif/L68dTQj.gif'),
  'LCtQPn8': require('../../assets/exercise-gif/LCtQPn8.gif'),
  'LEH9jxP': require('../../assets/exercise-gif/LEH9jxP.gif'),
  'LEprlgG': require('../../assets/exercise-gif/LEprlgG.gif'),
  'LFIOery': require('../../assets/exercise-gif/LFIOery.gif'),
  'LHWF7us': require('../../assets/exercise-gif/LHWF7us.gif'),
  'LIGZSTA': require('../../assets/exercise-gif/LIGZSTA.gif'),
  'LIlE5Tn': require('../../assets/exercise-gif/LIlE5Tn.gif'),
  'LL1UiTX': require('../../assets/exercise-gif/LL1UiTX.gif'),
  'LLNh6q5': require('../../assets/exercise-gif/LLNh6q5.gif'),
  'LMGXZn8': require('../../assets/exercise-gif/LMGXZn8.gif'),
  'LNE3wfo': require('../../assets/exercise-gif/LNE3wfo.gif'),
  'LQFOrMn': require('../../assets/exercise-gif/LQFOrMn.gif'),
  'LSTChY9': require('../../assets/exercise-gif/LSTChY9.gif'),
  'LWuA3aZ': require('../../assets/exercise-gif/LWuA3aZ.gif'),
  'LYJodFS': require('../../assets/exercise-gif/LYJodFS.gif'),
  'LeaZOIz': require('../../assets/exercise-gif/LeaZOIz.gif'),
  'LkoAWAE': require('../../assets/exercise-gif/LkoAWAE.gif'),
  'LlSe9IK': require('../../assets/exercise-gif/LlSe9IK.gif'),
  'LmaFNZS': require('../../assets/exercise-gif/LmaFNZS.gif'),
  'Ln9iTbU': require('../../assets/exercise-gif/Ln9iTbU.gif'),
  'LrV4s90': require('../../assets/exercise-gif/LrV4s90.gif'),
  'LsZkfU6': require('../../assets/exercise-gif/LsZkfU6.gif'),
  'Lsqrgh4': require('../../assets/exercise-gif/Lsqrgh4.gif'),
  'Lt3iWnf': require('../../assets/exercise-gif/Lt3iWnf.gif'),
  'LuBEORI': require('../../assets/exercise-gif/LuBEORI.gif'),
  'LzX8YEz': require('../../assets/exercise-gif/LzX8YEz.gif'),
  'M2Pm3zj': require('../../assets/exercise-gif/M2Pm3zj.gif'),
  'M5Y7GPg': require('../../assets/exercise-gif/M5Y7GPg.gif'),
  'M72BExt': require('../../assets/exercise-gif/M72BExt.gif'),
  'M74kdvm': require('../../assets/exercise-gif/M74kdvm.gif'),
  'M8IolhQ': require('../../assets/exercise-gif/M8IolhQ.gif'),
  'MCUhf1F': require('../../assets/exercise-gif/MCUhf1F.gif'),
  'MCkqdKE': require('../../assets/exercise-gif/MCkqdKE.gif'),
  'MDFxU4b': require('../../assets/exercise-gif/MDFxU4b.gif'),
  'MKIelrR': require('../../assets/exercise-gif/MKIelrR.gif'),
  'MRaFiZP': require('../../assets/exercise-gif/MRaFiZP.gif'),
  'MSfvriJ': require('../../assets/exercise-gif/MSfvriJ.gif'),
  'MU9HnE7': require('../../assets/exercise-gif/MU9HnE7.gif'),
  'MUic5zN': require('../../assets/exercise-gif/MUic5zN.gif'),
  'MY9P1WA': require('../../assets/exercise-gif/MY9P1WA.gif'),
  'MaMuGH6': require('../../assets/exercise-gif/MaMuGH6.gif'),
  'MgKwAAo': require('../../assets/exercise-gif/MgKwAAo.gif'),
  'MqNdIbe': require('../../assets/exercise-gif/MqNdIbe.gif'),
  'Mr8d4KA': require('../../assets/exercise-gif/Mr8d4KA.gif'),
  'MrgP9L6': require('../../assets/exercise-gif/MrgP9L6.gif'),
  'MvQPqVW': require('../../assets/exercise-gif/MvQPqVW.gif'),
  'Mxa7Cr8': require('../../assets/exercise-gif/Mxa7Cr8.gif'),
  'Mz6lLcW': require('../../assets/exercise-gif/Mz6lLcW.gif'),
  'MzNnwx9': require('../../assets/exercise-gif/MzNnwx9.gif'),
  'N3EirIW': require('../../assets/exercise-gif/N3EirIW.gif'),
  'N6dZN2I': require('../../assets/exercise-gif/N6dZN2I.gif'),
  'NAgVB3t': require('../../assets/exercise-gif/NAgVB3t.gif'),
  'NAkmgdx': require('../../assets/exercise-gif/NAkmgdx.gif'),
  'NCmbLCw': require('../../assets/exercise-gif/NCmbLCw.gif'),
  'NJzBsGJ': require('../../assets/exercise-gif/NJzBsGJ.gif'),
  'NKJ8o6x': require('../../assets/exercise-gif/NKJ8o6x.gif'),
  'NL6YBwN': require('../../assets/exercise-gif/NL6YBwN.gif'),
  'NN8nSNT': require('../../assets/exercise-gif/NN8nSNT.gif'),
  'NNoHCEA': require('../../assets/exercise-gif/NNoHCEA.gif'),
  'NZ5Qqkz': require('../../assets/exercise-gif/NZ5Qqkz.gif'),
  'NbVPDMW': require('../../assets/exercise-gif/NbVPDMW.gif'),
  'NdIb5Z1': require('../../assets/exercise-gif/NdIb5Z1.gif'),
  'NfP83rA': require('../../assets/exercise-gif/NfP83rA.gif'),
  'Nh3mvOO': require('../../assets/exercise-gif/Nh3mvOO.gif'),
  'NlfIbzq': require('../../assets/exercise-gif/NlfIbzq.gif'),
  'Nu7jqFE': require('../../assets/exercise-gif/Nu7jqFE.gif'),
  'NvfE43H': require('../../assets/exercise-gif/NvfE43H.gif'),
  'O2K9Vb5': require('../../assets/exercise-gif/O2K9Vb5.gif'),
  'O3INw8V': require('../../assets/exercise-gif/O3INw8V.gif'),
  'O4oIqQD': require('../../assets/exercise-gif/O4oIqQD.gif'),
  'O8Aq69u': require('../../assets/exercise-gif/O8Aq69u.gif'),
  'O8o7q4d': require('../../assets/exercise-gif/O8o7q4d.gif'),
  'O95afRA': require('../../assets/exercise-gif/O95afRA.gif'),
  'OAguZoG': require('../../assets/exercise-gif/OAguZoG.gif'),
  'OIFMAp1': require('../../assets/exercise-gif/OIFMAp1.gif'),
  'OJFgZJ0': require('../../assets/exercise-gif/OJFgZJ0.gif'),
  'OM46QHm': require('../../assets/exercise-gif/OM46QHm.gif'),
  'OPqShYN': require('../../assets/exercise-gif/OPqShYN.gif'),
  'OQ1otBN': require('../../assets/exercise-gif/OQ1otBN.gif'),
  'OTgkHwR': require('../../assets/exercise-gif/OTgkHwR.gif'),
  'OUQ0ZyW': require('../../assets/exercise-gif/OUQ0ZyW.gif'),
  'OVIKwsd': require('../../assets/exercise-gif/OVIKwsd.gif'),
  'OVLmUuL': require('../../assets/exercise-gif/OVLmUuL.gif'),
  'OVTZ65k': require('../../assets/exercise-gif/OVTZ65k.gif'),
  'OYFhXVD': require('../../assets/exercise-gif/OYFhXVD.gif'),
  'OaE7CpD': require('../../assets/exercise-gif/OaE7CpD.gif'),
  'OeL23VY': require('../../assets/exercise-gif/OeL23VY.gif'),
  'OmQ8w0p': require('../../assets/exercise-gif/OmQ8w0p.gif'),
  'OrETs32': require('../../assets/exercise-gif/OrETs32.gif'),
  'OxJk1fg': require('../../assets/exercise-gif/OxJk1fg.gif'),
  'OyoZ3Pu': require('../../assets/exercise-gif/OyoZ3Pu.gif'),
  'P14Dz9D': require('../../assets/exercise-gif/P14Dz9D.gif'),
  'P2lNrGL': require('../../assets/exercise-gif/P2lNrGL.gif'),
  'P2nRiUa': require('../../assets/exercise-gif/P2nRiUa.gif'),
  'P5p0j8B': require('../../assets/exercise-gif/P5p0j8B.gif'),
  'P7zSvul': require('../../assets/exercise-gif/P7zSvul.gif'),
  'P9GFBME': require('../../assets/exercise-gif/P9GFBME.gif'),
  'P9ZRyLT': require('../../assets/exercise-gif/P9ZRyLT.gif'),
  'PAgTVaK': require('../../assets/exercise-gif/PAgTVaK.gif'),
  'PCUYOMs': require('../../assets/exercise-gif/PCUYOMs.gif'),
  'PDHE73u': require('../../assets/exercise-gif/PDHE73u.gif'),
  'PDaMuyV': require('../../assets/exercise-gif/PDaMuyV.gif'),
  'PERjVm8': require('../../assets/exercise-gif/PERjVm8.gif'),
  'PG1kcIb': require('../../assets/exercise-gif/PG1kcIb.gif'),
  'PKlXuJW': require('../../assets/exercise-gif/PKlXuJW.gif'),
  'PM1PZjg': require('../../assets/exercise-gif/PM1PZjg.gif'),
  'PNtsX17': require('../../assets/exercise-gif/PNtsX17.gif'),
  'PQ2AtC3': require('../../assets/exercise-gif/PQ2AtC3.gif'),
  'PQStVXH': require('../../assets/exercise-gif/PQStVXH.gif'),
  'PQcUlDi': require('../../assets/exercise-gif/PQcUlDi.gif'),
  'PSlvNMs': require('../../assets/exercise-gif/PSlvNMs.gif'),
  'PXTIwgu': require('../../assets/exercise-gif/PXTIwgu.gif'),
  'PbzNu7c': require('../../assets/exercise-gif/PbzNu7c.gif'),
  'PcPe0P5': require('../../assets/exercise-gif/PcPe0P5.gif'),
  'PdmaD0N': require('../../assets/exercise-gif/PdmaD0N.gif'),
  'Pjbc0Kt': require('../../assets/exercise-gif/Pjbc0Kt.gif'),
  'PkCN2lv': require('../../assets/exercise-gif/PkCN2lv.gif'),
  'PnZJIrk': require('../../assets/exercise-gif/PnZJIrk.gif'),
  'Pr9Rhf4': require('../../assets/exercise-gif/Pr9Rhf4.gif'),
  'PrQbjvB': require('../../assets/exercise-gif/PrQbjvB.gif'),
  'PsVS1QP': require('../../assets/exercise-gif/PsVS1QP.gif'),
  'PskORrA': require('../../assets/exercise-gif/PskORrA.gif'),
  'PzNxakt': require('../../assets/exercise-gif/PzNxakt.gif'),
  'PzQanLE': require('../../assets/exercise-gif/PzQanLE.gif'),
  'Q2Eu1Ax': require('../../assets/exercise-gif/Q2Eu1Ax.gif'),
  'Q497lAE': require('../../assets/exercise-gif/Q497lAE.gif'),
  'Q4DSJPC': require('../../assets/exercise-gif/Q4DSJPC.gif'),
  'Q6bvyen': require('../../assets/exercise-gif/Q6bvyen.gif'),
  'QChZi3x': require('../../assets/exercise-gif/QChZi3x.gif'),
  'QFmz6ch': require('../../assets/exercise-gif/QFmz6ch.gif'),
  'QLL2gdc': require('../../assets/exercise-gif/QLL2gdc.gif'),
  'QLRmNeT': require('../../assets/exercise-gif/QLRmNeT.gif'),
  'QOA0FD0': require('../../assets/exercise-gif/QOA0FD0.gif'),
  'QQwxa8g': require('../../assets/exercise-gif/QQwxa8g.gif'),
  'QT5Q0nK': require('../../assets/exercise-gif/QT5Q0nK.gif'),
  'QTXKWPh': require('../../assets/exercise-gif/QTXKWPh.gif'),
  'QUDd8WS': require('../../assets/exercise-gif/QUDd8WS.gif'),
  'QY39eBr': require('../../assets/exercise-gif/QY39eBr.gif'),
  'QYysSLV': require('../../assets/exercise-gif/QYysSLV.gif'),
  'QZFv5ui': require('../../assets/exercise-gif/QZFv5ui.gif'),
  'Qa55kX1': require('../../assets/exercise-gif/Qa55kX1.gif'),
  'QfAKy1G': require('../../assets/exercise-gif/QfAKy1G.gif'),
  'Qj0HRAZ': require('../../assets/exercise-gif/Qj0HRAZ.gif'),
  'QjE2DcA': require('../../assets/exercise-gif/QjE2DcA.gif'),
  'Ql4g5s8': require('../../assets/exercise-gif/Ql4g5s8.gif'),
  'QoHIhPl': require('../../assets/exercise-gif/QoHIhPl.gif'),
  'QoSZo2Y': require('../../assets/exercise-gif/QoSZo2Y.gif'),
  'Qoujh3Q': require('../../assets/exercise-gif/Qoujh3Q.gif'),
  'QpXqiq8': require('../../assets/exercise-gif/QpXqiq8.gif'),
  'Qqi7bko': require('../../assets/exercise-gif/Qqi7bko.gif'),
  'QsSQWbf': require('../../assets/exercise-gif/QsSQWbf.gif'),
  'QyO6Uma': require('../../assets/exercise-gif/QyO6Uma.gif'),
  'Qyk5J3p': require('../../assets/exercise-gif/Qyk5J3p.gif'),
  'R1WYG5D': require('../../assets/exercise-gif/R1WYG5D.gif'),
  'R5swFnc': require('../../assets/exercise-gif/R5swFnc.gif'),
  'REGM1dE': require('../../assets/exercise-gif/REGM1dE.gif'),
  'REXmfVC': require('../../assets/exercise-gif/REXmfVC.gif'),
  'RGLscZM': require('../../assets/exercise-gif/RGLscZM.gif'),
  'RJa4tCo': require('../../assets/exercise-gif/RJa4tCo.gif'),
  'RJgzwny': require('../../assets/exercise-gif/RJgzwny.gif'),
  'RKjH6Lt': require('../../assets/exercise-gif/RKjH6Lt.gif'),
  'RQNVT10': require('../../assets/exercise-gif/RQNVT10.gif'),
  'RRWFUcw': require('../../assets/exercise-gif/RRWFUcw.gif'),
  'RSOsp5d': require('../../assets/exercise-gif/RSOsp5d.gif'),
  'RVwzP10': require('../../assets/exercise-gif/RVwzP10.gif'),
  'RYcV1kH': require('../../assets/exercise-gif/RYcV1kH.gif'),
  'RaflbWD': require('../../assets/exercise-gif/RaflbWD.gif'),
  'RgJDRR1': require('../../assets/exercise-gif/RgJDRR1.gif'),
  'RoV1Rfa': require('../../assets/exercise-gif/RoV1Rfa.gif'),
  'RqOtqD7': require('../../assets/exercise-gif/RqOtqD7.gif'),
  'Rr7S3yg': require('../../assets/exercise-gif/Rr7S3yg.gif'),
  'RrLske5': require('../../assets/exercise-gif/RrLske5.gif'),
  'Rsxr3xl': require('../../assets/exercise-gif/Rsxr3xl.gif'),
  'RtyAsy1': require('../../assets/exercise-gif/RtyAsy1.gif'),
  'RxayqAZ': require('../../assets/exercise-gif/RxayqAZ.gif'),
  'S1JXDAG': require('../../assets/exercise-gif/S1JXDAG.gif'),
  'S37C94C': require('../../assets/exercise-gif/S37C94C.gif'),
  'S4pwGlc': require('../../assets/exercise-gif/S4pwGlc.gif'),
  'S8mo30S': require('../../assets/exercise-gif/S8mo30S.gif'),
  'S93zLTG': require('../../assets/exercise-gif/S93zLTG.gif'),
  'S9zHIvU': require('../../assets/exercise-gif/S9zHIvU.gif'),
  'SGY8Zui': require('../../assets/exercise-gif/SGY8Zui.gif'),
  'SHUMp5H': require('../../assets/exercise-gif/SHUMp5H.gif'),
  'SJAA2IQ': require('../../assets/exercise-gif/SJAA2IQ.gif'),
  'SJqRxOt': require('../../assets/exercise-gif/SJqRxOt.gif'),
  'SKXQAx3': require('../../assets/exercise-gif/SKXQAx3.gif'),
  'SLKj2pX': require('../../assets/exercise-gif/SLKj2pX.gif'),
  'SNFfUff': require('../../assets/exercise-gif/SNFfUff.gif'),
  'SP3hUez': require('../../assets/exercise-gif/SP3hUez.gif'),
  'SSsBDwB': require('../../assets/exercise-gif/SSsBDwB.gif'),
  'SYJ4Bkt': require('../../assets/exercise-gif/SYJ4Bkt.gif'),
  'Sa8mzWc': require('../../assets/exercise-gif/Sa8mzWc.gif'),
  'SaDOwk7': require('../../assets/exercise-gif/SaDOwk7.gif'),
  'Ser9eQp': require('../../assets/exercise-gif/Ser9eQp.gif'),
  'SiWCcTN': require('../../assets/exercise-gif/SiWCcTN.gif'),
  'Sn8wxAI': require('../../assets/exercise-gif/Sn8wxAI.gif'),
  'Snj1wSv': require('../../assets/exercise-gif/Snj1wSv.gif'),
  'SpYC0Kp': require('../../assets/exercise-gif/SpYC0Kp.gif'),
  'SpsOSXk': require('../../assets/exercise-gif/SpsOSXk.gif'),
  'SxHteRW': require('../../assets/exercise-gif/SxHteRW.gif'),
  'SzX3uzM': require('../../assets/exercise-gif/SzX3uzM.gif'),
  'T0yTjgW': require('../../assets/exercise-gif/T0yTjgW.gif'),
  'T2fA5Ir': require('../../assets/exercise-gif/T2fA5Ir.gif'),
  'T2mxWqc': require('../../assets/exercise-gif/T2mxWqc.gif'),
  'T8UpLkb': require('../../assets/exercise-gif/T8UpLkb.gif'),
  'TBNaSNs': require('../../assets/exercise-gif/TBNaSNs.gif'),
  'TDYiji6': require('../../assets/exercise-gif/TDYiji6.gif'),
  'TFA88iB': require('../../assets/exercise-gif/TFA88iB.gif'),
  'TFqbd8t': require('../../assets/exercise-gif/TFqbd8t.gif'),
  'TUZLh71': require('../../assets/exercise-gif/TUZLh71.gif'),
  'TV87DNB': require('../../assets/exercise-gif/TV87DNB.gif'),
  'TVdivgY': require('../../assets/exercise-gif/TVdivgY.gif'),
  'TXtXc84': require('../../assets/exercise-gif/TXtXc84.gif'),
  'ThKP69G': require('../../assets/exercise-gif/ThKP69G.gif'),
  'TiaZTxx': require('../../assets/exercise-gif/TiaZTxx.gif'),
  'Tq6gbK6': require('../../assets/exercise-gif/Tq6gbK6.gif'),
  'U3ffHlY': require('../../assets/exercise-gif/U3ffHlY.gif'),
  'U5INZY6': require('../../assets/exercise-gif/U5INZY6.gif'),
  'U6G2gk9': require('../../assets/exercise-gif/U6G2gk9.gif'),
  'U7D9Fx3': require('../../assets/exercise-gif/U7D9Fx3.gif'),
  'UDlhcO8': require('../../assets/exercise-gif/UDlhcO8.gif'),
  'UDm6cGl': require('../../assets/exercise-gif/UDm6cGl.gif'),
  'UEjSrKI': require('../../assets/exercise-gif/UEjSrKI.gif'),
  'UFGF6gk': require('../../assets/exercise-gif/UFGF6gk.gif'),
  'UGhRD1A': require('../../assets/exercise-gif/UGhRD1A.gif'),
  'UHJlbu3': require('../../assets/exercise-gif/UHJlbu3.gif'),
  'UI81amT': require('../../assets/exercise-gif/UI81amT.gif'),
  'UIbGx6H': require('../../assets/exercise-gif/UIbGx6H.gif'),
  'UKWTJWR': require('../../assets/exercise-gif/UKWTJWR.gif'),
  'UM8mgyG': require('../../assets/exercise-gif/UM8mgyG.gif'),
  'UNAB8ak': require('../../assets/exercise-gif/UNAB8ak.gif'),
  'UOphC6N': require('../../assets/exercise-gif/UOphC6N.gif'),
  'UQr48Oi': require('../../assets/exercise-gif/UQr48Oi.gif'),
  'UVL20oz': require('../../assets/exercise-gif/UVL20oz.gif'),
  'UVo2Qs2': require('../../assets/exercise-gif/UVo2Qs2.gif'),
  'UXpKJoq': require('../../assets/exercise-gif/UXpKJoq.gif'),
  'UfePqpx': require('../../assets/exercise-gif/UfePqpx.gif'),
  'UgDm3oy': require('../../assets/exercise-gif/UgDm3oy.gif'),
  'UilDHSs': require('../../assets/exercise-gif/UilDHSs.gif'),
  'Ul5OFSV': require('../../assets/exercise-gif/Ul5OFSV.gif'),
  'Um8xUAc': require('../../assets/exercise-gif/Um8xUAc.gif'),
  'UmpPAAe': require('../../assets/exercise-gif/UmpPAAe.gif'),
  'UoX77uR': require('../../assets/exercise-gif/UoX77uR.gif'),
  'UpAlold': require('../../assets/exercise-gif/UpAlold.gif'),
  'UpWmA5E': require('../../assets/exercise-gif/UpWmA5E.gif'),
  'UtmIqcI': require('../../assets/exercise-gif/UtmIqcI.gif'),
  'Uto7l43': require('../../assets/exercise-gif/Uto7l43.gif'),
  'Uywa4S5': require('../../assets/exercise-gif/Uywa4S5.gif'),
  'UzkLrem': require('../../assets/exercise-gif/UzkLrem.gif'),
  'V07qpXy': require('../../assets/exercise-gif/V07qpXy.gif'),
  'V4ryaZa': require('../../assets/exercise-gif/V4ryaZa.gif'),
  'V7rWsT5': require('../../assets/exercise-gif/V7rWsT5.gif'),
  'VBAWRPG': require('../../assets/exercise-gif/VBAWRPG.gif'),
  'VEcJRo2': require('../../assets/exercise-gif/VEcJRo2.gif'),
  'VLYXo8S': require('../../assets/exercise-gif/VLYXo8S.gif'),
  'VO2qeJg': require('../../assets/exercise-gif/VO2qeJg.gif'),
  'VPPtusI': require('../../assets/exercise-gif/VPPtusI.gif'),
  'VQ3sNCn': require('../../assets/exercise-gif/VQ3sNCn.gif'),
  'VRBGPHB': require('../../assets/exercise-gif/VRBGPHB.gif'),
  'VW88JNd': require('../../assets/exercise-gif/VW88JNd.gif'),
  'VX5YKR5': require('../../assets/exercise-gif/VX5YKR5.gif'),
  'VYmYxK5': require('../../assets/exercise-gif/VYmYxK5.gif'),
  'VaP75jl': require('../../assets/exercise-gif/VaP75jl.gif'),
  'VdLZ3nB': require('../../assets/exercise-gif/VdLZ3nB.gif'),
  'VedGSby': require('../../assets/exercise-gif/VedGSby.gif'),
  'Vh0GsK4': require('../../assets/exercise-gif/Vh0GsK4.gif'),
  'VhX2JdE': require('../../assets/exercise-gif/VhX2JdE.gif'),
  'VjYliFZ': require('../../assets/exercise-gif/VjYliFZ.gif'),
  'VnfUNW7': require('../../assets/exercise-gif/VnfUNW7.gif'),
  'VsopqcV': require('../../assets/exercise-gif/VsopqcV.gif'),
  'VtTbiP3': require('../../assets/exercise-gif/VtTbiP3.gif'),
  'VuoerH0': require('../../assets/exercise-gif/VuoerH0.gif'),
  'Vvwjz6N': require('../../assets/exercise-gif/Vvwjz6N.gif'),
  'W1p7BND': require('../../assets/exercise-gif/W1p7BND.gif'),
  'W31mMjd': require('../../assets/exercise-gif/W31mMjd.gif'),
  'W6PxUkg': require('../../assets/exercise-gif/W6PxUkg.gif'),
  'W7yh3Yo': require('../../assets/exercise-gif/W7yh3Yo.gif'),
  'W8KAlkI': require('../../assets/exercise-gif/W8KAlkI.gif'),
  'W9pFVv1': require('../../assets/exercise-gif/W9pFVv1.gif'),
  'WCAvOfC': require('../../assets/exercise-gif/WCAvOfC.gif'),
  'WFucoe6': require('../../assets/exercise-gif/WFucoe6.gif'),
  'WKMQzCD': require('../../assets/exercise-gif/WKMQzCD.gif'),
  'WL4EmxJ': require('../../assets/exercise-gif/WL4EmxJ.gif'),
  'WLvTAv5': require('../../assets/exercise-gif/WLvTAv5.gif'),
  'WM6TvvW': require('../../assets/exercise-gif/WM6TvvW.gif'),
  'WME869U': require('../../assets/exercise-gif/WME869U.gif'),
  'WU9BLIs': require('../../assets/exercise-gif/WU9BLIs.gif'),
  'WVD66ff': require('../../assets/exercise-gif/WVD66ff.gif'),
  'WW95auq': require('../../assets/exercise-gif/WW95auq.gif'),
  'WWD6FzI': require('../../assets/exercise-gif/WWD6FzI.gif'),
  'WbNq5Xu': require('../../assets/exercise-gif/WbNq5Xu.gif'),
  'WcHl7ru': require('../../assets/exercise-gif/WcHl7ru.gif'),
  'WgJnBH5': require('../../assets/exercise-gif/WgJnBH5.gif'),
  'Wgaz7pm': require('../../assets/exercise-gif/Wgaz7pm.gif'),
  'Wgbn9qo': require('../../assets/exercise-gif/Wgbn9qo.gif'),
  'WhuFnR7': require('../../assets/exercise-gif/WhuFnR7.gif'),
  'WrYPP2g': require('../../assets/exercise-gif/WrYPP2g.gif'),
  'X3TCNEU': require('../../assets/exercise-gif/X3TCNEU.gif'),
  'X3cqyXz': require('../../assets/exercise-gif/X3cqyXz.gif'),
  'X6C6i5Y': require('../../assets/exercise-gif/X6C6i5Y.gif'),
  'X6ytgYZ': require('../../assets/exercise-gif/X6ytgYZ.gif'),
  'X7jbxra': require('../../assets/exercise-gif/X7jbxra.gif'),
  'XDOiFns': require('../../assets/exercise-gif/XDOiFns.gif'),
  'XE93sQZ': require('../../assets/exercise-gif/XE93sQZ.gif'),
  'XFc3vpY': require('../../assets/exercise-gif/XFc3vpY.gif'),
  'XIHEoCG': require('../../assets/exercise-gif/XIHEoCG.gif'),
  'XPUDTt7': require('../../assets/exercise-gif/XPUDTt7.gif'),
  'XSCHmiI': require('../../assets/exercise-gif/XSCHmiI.gif'),
  'XU3ePuv': require('../../assets/exercise-gif/XU3ePuv.gif'),
  'XUUD0Fs': require('../../assets/exercise-gif/XUUD0Fs.gif'),
  'XVDdcoj': require('../../assets/exercise-gif/XVDdcoj.gif'),
  'XVzF3iZ': require('../../assets/exercise-gif/XVzF3iZ.gif'),
  'XaaRnRn': require('../../assets/exercise-gif/XaaRnRn.gif'),
  'XalXcvM': require('../../assets/exercise-gif/XalXcvM.gif'),
  'Xd65M9w': require('../../assets/exercise-gif/Xd65M9w.gif'),
  'XeMvLgE': require('../../assets/exercise-gif/XeMvLgE.gif'),
  'XgWyAiA': require('../../assets/exercise-gif/XgWyAiA.gif'),
  'XhfS1DZ': require('../../assets/exercise-gif/XhfS1DZ.gif'),
  'XlZ4lAC': require('../../assets/exercise-gif/XlZ4lAC.gif'),
  'XooAdhl': require('../../assets/exercise-gif/XooAdhl.gif'),
  'XqYQ9JA': require('../../assets/exercise-gif/XqYQ9JA.gif'),
  'XsCcxCC': require('../../assets/exercise-gif/XsCcxCC.gif'),
  'Xy4jlWA': require('../../assets/exercise-gif/Xy4jlWA.gif'),
  'Y1MsI1l': require('../../assets/exercise-gif/Y1MsI1l.gif'),
  'Y4BRNQF': require('../../assets/exercise-gif/Y4BRNQF.gif'),
  'Y4QlY8z': require('../../assets/exercise-gif/Y4QlY8z.gif'),
  'Y5X65IB': require('../../assets/exercise-gif/Y5X65IB.gif'),
  'Y7YcmIJ': require('../../assets/exercise-gif/Y7YcmIJ.gif'),
  'Y8dOJlH': require('../../assets/exercise-gif/Y8dOJlH.gif'),
  'Y9hNPcN': require('../../assets/exercise-gif/Y9hNPcN.gif'),
  'YA2HKGz': require('../../assets/exercise-gif/YA2HKGz.gif'),
  'YAk5dIw': require('../../assets/exercise-gif/YAk5dIw.gif'),
  'YIUAtYf': require('../../assets/exercise-gif/YIUAtYf.gif'),
  'YPoVrBi': require('../../assets/exercise-gif/YPoVrBi.gif'),
  'YRaCa5Y': require('../../assets/exercise-gif/YRaCa5Y.gif'),
  'YTur5nR': require('../../assets/exercise-gif/YTur5nR.gif'),
  'YUYAMEj': require('../../assets/exercise-gif/YUYAMEj.gif'),
  'YZ4961r': require('../../assets/exercise-gif/YZ4961r.gif'),
  'Ye5Qxb0': require('../../assets/exercise-gif/Ye5Qxb0.gif'),
  'Yg7MJAT': require('../../assets/exercise-gif/Yg7MJAT.gif'),
  'YqJw82s': require('../../assets/exercise-gif/YqJw82s.gif'),
  'Ys97II0': require('../../assets/exercise-gif/Ys97II0.gif'),
  'YtaCTYl': require('../../assets/exercise-gif/YtaCTYl.gif'),
  'YtgD7Xq': require('../../assets/exercise-gif/YtgD7Xq.gif'),
  'YwnI4ja': require('../../assets/exercise-gif/YwnI4ja.gif'),
  'Yza7XrQ': require('../../assets/exercise-gif/Yza7XrQ.gif'),
  'Z5YStHW': require('../../assets/exercise-gif/Z5YStHW.gif'),
  'ZA8b5hc': require('../../assets/exercise-gif/ZA8b5hc.gif'),
  'ZEkjZDi': require('../../assets/exercise-gif/ZEkjZDi.gif'),
  'ZH68exZ': require('../../assets/exercise-gif/ZH68exZ.gif'),
  'ZIViNh1': require('../../assets/exercise-gif/ZIViNh1.gif'),
  'ZNgOYQU': require('../../assets/exercise-gif/ZNgOYQU.gif'),
  'ZOuKWir': require('../../assets/exercise-gif/ZOuKWir.gif'),
  'ZSJNetl': require('../../assets/exercise-gif/ZSJNetl.gif'),
  'ZSY3MsL': require('../../assets/exercise-gif/ZSY3MsL.gif'),
  'ZX9UZmj': require('../../assets/exercise-gif/ZX9UZmj.gif'),
  'ZXnjcOQ': require('../../assets/exercise-gif/ZXnjcOQ.gif'),
  'ZZKbeMw': require('../../assets/exercise-gif/ZZKbeMw.gif'),
  'ZZTGMKh': require('../../assets/exercise-gif/ZZTGMKh.gif'),
  'Ze7MoIb': require('../../assets/exercise-gif/Ze7MoIb.gif'),
  'ZfyAGhK': require('../../assets/exercise-gif/ZfyAGhK.gif'),
  'Zg3XY7P': require('../../assets/exercise-gif/Zg3XY7P.gif'),
  'ZgsNQ6d': require('../../assets/exercise-gif/ZgsNQ6d.gif'),
  'ZgwWBoC': require('../../assets/exercise-gif/ZgwWBoC.gif'),
  'ZnJHhMk': require('../../assets/exercise-gif/ZnJHhMk.gif'),
  'ZqNOWQ6': require('../../assets/exercise-gif/ZqNOWQ6.gif'),
  'ZsiqXYa': require('../../assets/exercise-gif/ZsiqXYa.gif'),
  'ZuPXtCK': require('../../assets/exercise-gif/ZuPXtCK.gif'),
  'ZuXu4Eq': require('../../assets/exercise-gif/ZuXu4Eq.gif'),
  'ZujAdR9': require('../../assets/exercise-gif/ZujAdR9.gif'),
  'Zwiw7XR': require('../../assets/exercise-gif/Zwiw7XR.gif'),
  'a4F9Oyc': require('../../assets/exercise-gif/a4F9Oyc.gif'),
  'a8VDgLw': require('../../assets/exercise-gif/a8VDgLw.gif'),
  'aDoFKrE': require('../../assets/exercise-gif/aDoFKrE.gif'),
  'aHDy5O5': require('../../assets/exercise-gif/aHDy5O5.gif'),
  'aTNKZiC': require('../../assets/exercise-gif/aTNKZiC.gif'),
  'aVs3BR3': require('../../assets/exercise-gif/aVs3BR3.gif'),
  'aWedzZX': require('../../assets/exercise-gif/aWedzZX.gif'),
  'aXcUyKb': require('../../assets/exercise-gif/aXcUyKb.gif'),
  'aXtJhlg': require('../../assets/exercise-gif/aXtJhlg.gif'),
  'aaXr7ld': require('../../assets/exercise-gif/aaXr7ld.gif'),
  'aaxA3cm': require('../../assets/exercise-gif/aaxA3cm.gif'),
  'ae9UoXQ': require('../../assets/exercise-gif/ae9UoXQ.gif'),
  'aee2Fcj': require('../../assets/exercise-gif/aee2Fcj.gif'),
  'afv0ZAS': require('../../assets/exercise-gif/afv0ZAS.gif'),
  'ainizkb': require('../../assets/exercise-gif/ainizkb.gif'),
  'aqvSOQE': require('../../assets/exercise-gif/aqvSOQE.gif'),
  'arsYEd3': require('../../assets/exercise-gif/arsYEd3.gif'),
  'arvaszz': require('../../assets/exercise-gif/arvaszz.gif'),
  'aumB2IV': require('../../assets/exercise-gif/aumB2IV.gif'),
  'awG04cF': require('../../assets/exercise-gif/awG04cF.gif'),
  'ayAHcEm': require('../../assets/exercise-gif/ayAHcEm.gif'),
  'b2Uoz54': require('../../assets/exercise-gif/b2Uoz54.gif'),
  'b4b6afT': require('../../assets/exercise-gif/b4b6afT.gif'),
  'b5uBMv2': require('../../assets/exercise-gif/b5uBMv2.gif'),
  'b63ZzGe': require('../../assets/exercise-gif/b63ZzGe.gif'),
  'b6hQYMb': require('../../assets/exercise-gif/b6hQYMb.gif'),
  'b9kqlBy': require('../../assets/exercise-gif/b9kqlBy.gif'),
  'bBi35y3': require('../../assets/exercise-gif/bBi35y3.gif'),
  'bJYHBIN': require('../../assets/exercise-gif/bJYHBIN.gif'),
  'bKWbrTA': require('../../assets/exercise-gif/bKWbrTA.gif'),
  'bLyQokI': require('../../assets/exercise-gif/bLyQokI.gif'),
  'bOOdeyc': require('../../assets/exercise-gif/bOOdeyc.gif'),
  'bQHPBU3': require('../../assets/exercise-gif/bQHPBU3.gif'),
  'bQy2Eni': require('../../assets/exercise-gif/bQy2Eni.gif'),
  'bRlbdjK': require('../../assets/exercise-gif/bRlbdjK.gif'),
  'bTpEUcm': require('../../assets/exercise-gif/bTpEUcm.gif'),
  'bWlZvXh': require('../../assets/exercise-gif/bWlZvXh.gif'),
  'bWxq4op': require('../../assets/exercise-gif/bWxq4op.gif'),
  'bZGHsAZ': require('../../assets/exercise-gif/bZGHsAZ.gif'),
  'bZq4bwK': require('../../assets/exercise-gif/bZq4bwK.gif'),
  'bbLR7fB': require('../../assets/exercise-gif/bbLR7fB.gif'),
  'bd5b860': require('../../assets/exercise-gif/bd5b860.gif'),
  'bdWcbaU': require('../../assets/exercise-gif/bdWcbaU.gif'),
  'bfiHMpI': require('../../assets/exercise-gif/bfiHMpI.gif'),
  'bjqbauy': require('../../assets/exercise-gif/bjqbauy.gif'),
  'blBXysN': require('../../assets/exercise-gif/blBXysN.gif'),
  'bmBf7LN': require('../../assets/exercise-gif/bmBf7LN.gif'),
  'bmwlYvD': require('../../assets/exercise-gif/bmwlYvD.gif'),
  'bndCa3Q': require('../../assets/exercise-gif/bndCa3Q.gif'),
  'bpJL2Qs': require('../../assets/exercise-gif/bpJL2Qs.gif'),
  'c16nYGA': require('../../assets/exercise-gif/c16nYGA.gif'),
  'c3Pfhti': require('../../assets/exercise-gif/c3Pfhti.gif'),
  'c3QQLPi': require('../../assets/exercise-gif/c3QQLPi.gif'),
  'c8f5cSY': require('../../assets/exercise-gif/c8f5cSY.gif'),
  'c8oybX6': require('../../assets/exercise-gif/c8oybX6.gif'),
  'c9MnDRp': require('../../assets/exercise-gif/c9MnDRp.gif'),
  'cA9FuWG': require('../../assets/exercise-gif/cA9FuWG.gif'),
  'cALKspW': require('../../assets/exercise-gif/cALKspW.gif'),
  'cALkHHX': require('../../assets/exercise-gif/cALkHHX.gif'),
  'cAvTaSg': require('../../assets/exercise-gif/cAvTaSg.gif'),
  'cJgSTmh': require('../../assets/exercise-gif/cJgSTmh.gif'),
  'cQ19bBP': require('../../assets/exercise-gif/cQ19bBP.gif'),
  'cWemPG8': require('../../assets/exercise-gif/cWemPG8.gif'),
  'cbuFJrn': require('../../assets/exercise-gif/cbuFJrn.gif'),
  'chfnQnM': require('../../assets/exercise-gif/chfnQnM.gif'),
  'cuC7529': require('../../assets/exercise-gif/cuC7529.gif'),
  'cuKYxhu': require('../../assets/exercise-gif/cuKYxhu.gif'),
  'cwsAI4G': require('../../assets/exercise-gif/cwsAI4G.gif'),
  'd1GgzTU': require('../../assets/exercise-gif/d1GgzTU.gif'),
  'd5bTEPV': require('../../assets/exercise-gif/d5bTEPV.gif'),
  'd7z1Y7V': require('../../assets/exercise-gif/d7z1Y7V.gif'),
  'd960PgE': require('../../assets/exercise-gif/d960PgE.gif'),
  'd9Xaxq6': require('../../assets/exercise-gif/d9Xaxq6.gif'),
  'dAJscVq': require('../../assets/exercise-gif/dAJscVq.gif'),
  'dB07vDu': require('../../assets/exercise-gif/dB07vDu.gif'),
  'dCJnuVq': require('../../assets/exercise-gif/dCJnuVq.gif'),
  'dCPESfR': require('../../assets/exercise-gif/dCPESfR.gif'),
  'dFSNDOA': require('../../assets/exercise-gif/dFSNDOA.gif'),
  'dG5Smob': require('../../assets/exercise-gif/dG5Smob.gif'),
  'dG7tG5y': require('../../assets/exercise-gif/dG7tG5y.gif'),
  'dK9394r': require('../../assets/exercise-gif/dK9394r.gif'),
  'dNFYIU1': require('../../assets/exercise-gif/dNFYIU1.gif'),
  'dPmaUaU': require('../../assets/exercise-gif/dPmaUaU.gif'),
  'dRTfGZT': require('../../assets/exercise-gif/dRTfGZT.gif'),
  'dTg95eZ': require('../../assets/exercise-gif/dTg95eZ.gif'),
  'dU605di': require('../../assets/exercise-gif/dU605di.gif'),
  'dVeWXf2': require('../../assets/exercise-gif/dVeWXf2.gif'),
  'dXz8zjF': require('../../assets/exercise-gif/dXz8zjF.gif'),
  'dZl9Q27': require('../../assets/exercise-gif/dZl9Q27.gif'),
  'da4cXST': require('../../assets/exercise-gif/da4cXST.gif'),
  'daBmy1Y': require('../../assets/exercise-gif/daBmy1Y.gif'),
  'dmgMp3n': require('../../assets/exercise-gif/dmgMp3n.gif'),
  'drfGhTV': require('../../assets/exercise-gif/drfGhTV.gif'),
  'dzz6BiV': require('../../assets/exercise-gif/dzz6BiV.gif'),
  'e1e76I2': require('../../assets/exercise-gif/e1e76I2.gif'),
  'e25F58f': require('../../assets/exercise-gif/e25F58f.gif'),
  'e4aFmFY': require('../../assets/exercise-gif/e4aFmFY.gif'),
  'e4ojVhP': require('../../assets/exercise-gif/e4ojVhP.gif'),
  'eGDudUV': require('../../assets/exercise-gif/eGDudUV.gif'),
  'eHBlPsa': require('../../assets/exercise-gif/eHBlPsa.gif'),
  'eOCOwIR': require('../../assets/exercise-gif/eOCOwIR.gif'),
  'eOG0r6v': require('../../assets/exercise-gif/eOG0r6v.gif'),
  'eOrFCnx': require('../../assets/exercise-gif/eOrFCnx.gif'),
  'eVxAzgz': require('../../assets/exercise-gif/eVxAzgz.gif'),
  'eXFXCY0': require('../../assets/exercise-gif/eXFXCY0.gif'),
  'eXMFHww': require('../../assets/exercise-gif/eXMFHww.gif'),
  'eYmsEPR': require('../../assets/exercise-gif/eYmsEPR.gif'),
  'eYnzaCm': require('../../assets/exercise-gif/eYnzaCm.gif'),
  'eZ79rbI': require('../../assets/exercise-gif/eZ79rbI.gif'),
  'eZyBC3j': require('../../assets/exercise-gif/eZyBC3j.gif'),
  'ealLwvX': require('../../assets/exercise-gif/ealLwvX.gif'),
  'echClj7': require('../../assets/exercise-gif/echClj7.gif'),
  'ecl28tP': require('../../assets/exercise-gif/ecl28tP.gif'),
  'ecpY0rH': require('../../assets/exercise-gif/ecpY0rH.gif'),
  'elhhVgj': require('../../assets/exercise-gif/elhhVgj.gif'),
  'en550rk': require('../../assets/exercise-gif/en550rk.gif'),
  'enxnJcM': require('../../assets/exercise-gif/enxnJcM.gif'),
  'epOSYUZ': require('../../assets/exercise-gif/epOSYUZ.gif'),
  'euI1BwR': require('../../assets/exercise-gif/euI1BwR.gif'),
  'euq4pwp': require('../../assets/exercise-gif/euq4pwp.gif'),
  'ezTvXcr': require('../../assets/exercise-gif/ezTvXcr.gif'),
  'f1jf47L': require('../../assets/exercise-gif/f1jf47L.gif'),
  'f38OEuO': require('../../assets/exercise-gif/f38OEuO.gif'),
  'f4xtKBj': require('../../assets/exercise-gif/f4xtKBj.gif'),
  'f7Y9eDZ': require('../../assets/exercise-gif/f7Y9eDZ.gif'),
  'f7fnAIB': require('../../assets/exercise-gif/f7fnAIB.gif'),
  'f91FwXG': require('../../assets/exercise-gif/f91FwXG.gif'),
  'f9lVSSI': require('../../assets/exercise-gif/f9lVSSI.gif'),
  'fBnPpzd': require('../../assets/exercise-gif/fBnPpzd.gif'),
  'fF6GKVh': require('../../assets/exercise-gif/fF6GKVh.gif'),
  'fI18Rbc': require('../../assets/exercise-gif/fI18Rbc.gif'),
  'fKZgDEO': require('../../assets/exercise-gif/fKZgDEO.gif'),
  'fNGumX0': require('../../assets/exercise-gif/fNGumX0.gif'),
  'fSrPP6B': require('../../assets/exercise-gif/fSrPP6B.gif'),
  'fTlkJop': require('../../assets/exercise-gif/fTlkJop.gif'),
  'fUBheHs': require('../../assets/exercise-gif/fUBheHs.gif'),
  'fXfqg1E': require('../../assets/exercise-gif/fXfqg1E.gif'),
  'fY68AyX': require('../../assets/exercise-gif/fY68AyX.gif'),
  'fZFZ704': require('../../assets/exercise-gif/fZFZ704.gif'),
  'faHKVkK': require('../../assets/exercise-gif/faHKVkK.gif'),
  'ffQsyBj': require('../../assets/exercise-gif/ffQsyBj.gif'),
  'fgc9Xdl': require('../../assets/exercise-gif/fgc9Xdl.gif'),
  'fhZQPlV': require('../../assets/exercise-gif/fhZQPlV.gif'),
  'fjjY3N4': require('../../assets/exercise-gif/fjjY3N4.gif'),
  'fprd84i': require('../../assets/exercise-gif/fprd84i.gif'),
  'fy7Tgy4': require('../../assets/exercise-gif/fy7Tgy4.gif'),
  'g2oKspu': require('../../assets/exercise-gif/g2oKspu.gif'),
  'g376LuL': require('../../assets/exercise-gif/g376LuL.gif'),
  'g9AsZ8P': require('../../assets/exercise-gif/g9AsZ8P.gif'),
  'gAwDzB3': require('../../assets/exercise-gif/gAwDzB3.gif'),
  'gEyURal': require('../../assets/exercise-gif/gEyURal.gif'),
  'gFyFj9z': require('../../assets/exercise-gif/gFyFj9z.gif'),
  'gGNQmVt': require('../../assets/exercise-gif/gGNQmVt.gif'),
  'gH5fRsC': require('../../assets/exercise-gif/gH5fRsC.gif'),
  'gKozT8X': require('../../assets/exercise-gif/gKozT8X.gif'),
  'gMyx3Qn': require('../../assets/exercise-gif/gMyx3Qn.gif'),
  'gSO0KpB': require('../../assets/exercise-gif/gSO0KpB.gif'),
  'gSw59a4': require('../../assets/exercise-gif/gSw59a4.gif'),
  'gTGciXz': require('../../assets/exercise-gif/gTGciXz.gif'),
  'gUjqdei': require('../../assets/exercise-gif/gUjqdei.gif'),
  'gVlnLIJ': require('../../assets/exercise-gif/gVlnLIJ.gif'),
  'gWcZD4q': require('../../assets/exercise-gif/gWcZD4q.gif'),
  'gdPIyyO': require('../../assets/exercise-gif/gdPIyyO.gif'),
  'gf3ZjB9': require('../../assets/exercise-gif/gf3ZjB9.gif'),
  'gfk9kD4': require('../../assets/exercise-gif/gfk9kD4.gif'),
  'goJ6ezq': require('../../assets/exercise-gif/goJ6ezq.gif'),
  'gscGLOU': require('../../assets/exercise-gif/gscGLOU.gif'),
  'gtO1ErP': require('../../assets/exercise-gif/gtO1ErP.gif'),
  'guT8YnS': require('../../assets/exercise-gif/guT8YnS.gif'),
  'gvsWLQw': require('../../assets/exercise-gif/gvsWLQw.gif'),
  'gw9PqGk': require('../../assets/exercise-gif/gw9PqGk.gif'),
  'gx7s7uF': require('../../assets/exercise-gif/gx7s7uF.gif'),
  'h1ezqSu': require('../../assets/exercise-gif/h1ezqSu.gif'),
  'h8LFzo9': require('../../assets/exercise-gif/h8LFzo9.gif'),
  'hBGWILP': require('../../assets/exercise-gif/hBGWILP.gif'),
  'hC6oYY5': require('../../assets/exercise-gif/hC6oYY5.gif'),
  'hCjGsRQ': require('../../assets/exercise-gif/hCjGsRQ.gif'),
  'hHy8tQG': require('../../assets/exercise-gif/hHy8tQG.gif'),
  'hMEptv0': require('../../assets/exercise-gif/hMEptv0.gif'),
  'hTLtkXL': require('../../assets/exercise-gif/hTLtkXL.gif'),
  'hVzPY5j': require('../../assets/exercise-gif/hVzPY5j.gif'),
  'hacCyUv': require('../../assets/exercise-gif/hacCyUv.gif'),
  'hbY9wqG': require('../../assets/exercise-gif/hbY9wqG.gif'),
  'hfmQ0Tz': require('../../assets/exercise-gif/hfmQ0Tz.gif'),
  'hjWjJEm': require('../../assets/exercise-gif/hjWjJEm.gif'),
  'hl8DUh8': require('../../assets/exercise-gif/hl8DUh8.gif'),
  'hnOYgH3': require('../../assets/exercise-gif/hnOYgH3.gif'),
  'hoXt6wv': require('../../assets/exercise-gif/hoXt6wv.gif'),
  'hq2hyDH': require('../../assets/exercise-gif/hq2hyDH.gif'),
  'hrVQWvE': require('../../assets/exercise-gif/hrVQWvE.gif'),
  'hrrS0Ed': require('../../assets/exercise-gif/hrrS0Ed.gif'),
  'ht8xDrP': require('../../assets/exercise-gif/ht8xDrP.gif'),
  'hvHhCv8': require('../../assets/exercise-gif/hvHhCv8.gif'),
  'hvV79Si': require('../../assets/exercise-gif/hvV79Si.gif'),
  'hwygydB': require('../../assets/exercise-gif/hwygydB.gif'),
  'hxyTtWj': require('../../assets/exercise-gif/hxyTtWj.gif'),
  'i11JWU7': require('../../assets/exercise-gif/i11JWU7.gif'),
  'i4JkUaL': require('../../assets/exercise-gif/i4JkUaL.gif'),
  'i5cEhka': require('../../assets/exercise-gif/i5cEhka.gif'),
  'i6LWjok': require('../../assets/exercise-gif/i6LWjok.gif'),
  'i8BdLTK': require('../../assets/exercise-gif/i8BdLTK.gif'),
  'iCPqbki': require('../../assets/exercise-gif/iCPqbki.gif'),
  'iDGtjyi': require('../../assets/exercise-gif/iDGtjyi.gif'),
  'iFsqlCD': require('../../assets/exercise-gif/iFsqlCD.gif'),
  'iK59oEA': require('../../assets/exercise-gif/iK59oEA.gif'),
  'iPm26QU': require('../../assets/exercise-gif/iPm26QU.gif'),
  'iQ241UP': require('../../assets/exercise-gif/iQ241UP.gif'),
  'iYzB0Cz': require('../../assets/exercise-gif/iYzB0Cz.gif'),
  'iZop9xO': require('../../assets/exercise-gif/iZop9xO.gif'),
  'ia6kIIl': require('../../assets/exercise-gif/ia6kIIl.gif'),
  'iaapw0g': require('../../assets/exercise-gif/iaapw0g.gif'),
  'ila4NZS': require('../../assets/exercise-gif/ila4NZS.gif'),
  'iny3m5y': require('../../assets/exercise-gif/iny3m5y.gif'),
  'ioTf098': require('../../assets/exercise-gif/ioTf098.gif'),
  'ipvgBnC': require('../../assets/exercise-gif/ipvgBnC.gif'),
  'iqH55N8': require('../../assets/exercise-gif/iqH55N8.gif'),
  'isAAZWA': require('../../assets/exercise-gif/isAAZWA.gif'),
  'isofgzg': require('../../assets/exercise-gif/isofgzg.gif'),
  'izMnLqz': require('../../assets/exercise-gif/izMnLqz.gif'),
  'j6uIfep': require('../../assets/exercise-gif/j6uIfep.gif'),
  'j74M6Zn': require('../../assets/exercise-gif/j74M6Zn.gif'),
  'j7XMAyn': require('../../assets/exercise-gif/j7XMAyn.gif'),
  'j9Q5crt': require('../../assets/exercise-gif/j9Q5crt.gif'),
  'jCBOdh0': require('../../assets/exercise-gif/jCBOdh0.gif'),
  'jCrtE9b': require('../../assets/exercise-gif/jCrtE9b.gif'),
  'jDOKRM5': require('../../assets/exercise-gif/jDOKRM5.gif'),
  'jDnrkar': require('../../assets/exercise-gif/jDnrkar.gif'),
  'jFtipLl': require('../../assets/exercise-gif/jFtipLl.gif'),
  'jHAnWmT': require('../../assets/exercise-gif/jHAnWmT.gif'),
  'jK2hZ6n': require('../../assets/exercise-gif/jK2hZ6n.gif'),
  'jNU1gFQ': require('../../assets/exercise-gif/jNU1gFQ.gif'),
  'jQGwmxN': require('../../assets/exercise-gif/jQGwmxN.gif'),
  'jTkSc6o': require('../../assets/exercise-gif/jTkSc6o.gif'),
  'jV65tKx': require('../../assets/exercise-gif/jV65tKx.gif'),
  'jdiExfW': require('../../assets/exercise-gif/jdiExfW.gif'),
  'jeHtrlO': require('../../assets/exercise-gif/jeHtrlO.gif'),
  'jgbvVJ0': require('../../assets/exercise-gif/jgbvVJ0.gif'),
  'jivWf8n': require('../../assets/exercise-gif/jivWf8n.gif'),
  'jjUPrze': require('../../assets/exercise-gif/jjUPrze.gif'),
  'jl6uxZV': require('../../assets/exercise-gif/jl6uxZV.gif'),
  'jpgqxiS': require('../../assets/exercise-gif/jpgqxiS.gif'),
  'jtFKbt5': require('../../assets/exercise-gif/jtFKbt5.gif'),
  'jvEXp4N': require('../../assets/exercise-gif/jvEXp4N.gif'),
  'jvp6DiD': require('../../assets/exercise-gif/jvp6DiD.gif'),
  'k5IpyHg': require('../../assets/exercise-gif/k5IpyHg.gif'),
  'k6tUeqS': require('../../assets/exercise-gif/k6tUeqS.gif'),
  'kKYTkjJ': require('../../assets/exercise-gif/kKYTkjJ.gif'),
  'kLiIFdB': require('../../assets/exercise-gif/kLiIFdB.gif'),
  'kMzUs9Y': require('../../assets/exercise-gif/kMzUs9Y.gif'),
  'kTbSH9h': require('../../assets/exercise-gif/kTbSH9h.gif'),
  'kXaIn5A': require('../../assets/exercise-gif/kXaIn5A.gif'),
  'kesXOpB': require('../../assets/exercise-gif/kesXOpB.gif'),
  'khlHMqs': require('../../assets/exercise-gif/khlHMqs.gif'),
  'kiJ4Z2K': require('../../assets/exercise-gif/kiJ4Z2K.gif'),
  'kj3hy6W': require('../../assets/exercise-gif/kj3hy6W.gif'),
  'kjE55n5': require('../../assets/exercise-gif/kjE55n5.gif'),
  'kjJ3VoQ': require('../../assets/exercise-gif/kjJ3VoQ.gif'),
  'kk39rUy': require('../../assets/exercise-gif/kk39rUy.gif'),
  'km0sQC0': require('../../assets/exercise-gif/km0sQC0.gif'),
  'km2Ljzj': require('../../assets/exercise-gif/km2Ljzj.gif'),
  'kmVVAfu': require('../../assets/exercise-gif/kmVVAfu.gif'),
  'kont8Ut': require('../../assets/exercise-gif/kont8Ut.gif'),
  'kprile3': require('../../assets/exercise-gif/kprile3.gif'),
  'ktf3nvW': require('../../assets/exercise-gif/ktf3nvW.gif'),
  'ktsFQAZ': require('../../assets/exercise-gif/ktsFQAZ.gif'),
  'kuMiR2T': require('../../assets/exercise-gif/kuMiR2T.gif'),
  'kuXhl0o': require('../../assets/exercise-gif/kuXhl0o.gif'),
  'ky8FLU8': require('../../assets/exercise-gif/ky8FLU8.gif'),
  'lBDjFxJ': require('../../assets/exercise-gif/lBDjFxJ.gif'),
  'lCKm4Rs': require('../../assets/exercise-gif/lCKm4Rs.gif'),
  'lFBTISi': require('../../assets/exercise-gif/lFBTISi.gif'),
  'lFhb2Rw': require('../../assets/exercise-gif/lFhb2Rw.gif'),
  'lHeUULr': require('../../assets/exercise-gif/lHeUULr.gif'),
  'lI7easp': require('../../assets/exercise-gif/lI7easp.gif'),
  'lJJ7Yq8': require('../../assets/exercise-gif/lJJ7Yq8.gif'),
  'lRcrlH8': require('../../assets/exercise-gif/lRcrlH8.gif'),
  'laVRfDf': require('../../assets/exercise-gif/laVRfDf.gif'),
  'lyKCLmK': require('../../assets/exercise-gif/lyKCLmK.gif'),
  'm0tCHqc': require('../../assets/exercise-gif/m0tCHqc.gif'),
  'mAYqY4M': require('../../assets/exercise-gif/mAYqY4M.gif'),
  'mExgrF9': require('../../assets/exercise-gif/mExgrF9.gif'),
  'mKwcrHn': require('../../assets/exercise-gif/mKwcrHn.gif'),
  'mQ1tBXn': require('../../assets/exercise-gif/mQ1tBXn.gif'),
  'mTT3KLn': require('../../assets/exercise-gif/mTT3KLn.gif'),
  'mWBtgmb': require('../../assets/exercise-gif/mWBtgmb.gif'),
  'mWppALS': require('../../assets/exercise-gif/mWppALS.gif'),
  'mbkgB44': require('../../assets/exercise-gif/mbkgB44.gif'),
  'mgejmGP': require('../../assets/exercise-gif/mgejmGP.gif'),
  'mnzcrIB': require('../../assets/exercise-gif/mnzcrIB.gif'),
  'mpKZGWz': require('../../assets/exercise-gif/mpKZGWz.gif'),
  'mpYUPkA': require('../../assets/exercise-gif/mpYUPkA.gif'),
  'mr7pkqP': require('../../assets/exercise-gif/mr7pkqP.gif'),
  'ms7tjSG': require('../../assets/exercise-gif/ms7tjSG.gif'),
  'mtXengz': require('../../assets/exercise-gif/mtXengz.gif'),
  'mu5Guxt': require('../../assets/exercise-gif/mu5Guxt.gif'),
  'mweqJin': require('../../assets/exercise-gif/mweqJin.gif'),
  'mwpPcr1': require('../../assets/exercise-gif/mwpPcr1.gif'),
  'my33uHU': require('../../assets/exercise-gif/my33uHU.gif'),
  'myJeTAe': require('../../assets/exercise-gif/myJeTAe.gif'),
  'myfUsKf': require('../../assets/exercise-gif/myfUsKf.gif'),
  'mym4hJo': require('../../assets/exercise-gif/mym4hJo.gif'),
  'n5cWCsI': require('../../assets/exercise-gif/n5cWCsI.gif'),
  'nAuHPcD': require('../../assets/exercise-gif/nAuHPcD.gif'),
  'nCU1Ekp': require('../../assets/exercise-gif/nCU1Ekp.gif'),
  'nDK1HJ0': require('../../assets/exercise-gif/nDK1HJ0.gif'),
  'nFHk9fU': require('../../assets/exercise-gif/nFHk9fU.gif'),
  'nFUwqG6': require('../../assets/exercise-gif/nFUwqG6.gif'),
  'nFc4FyV': require('../../assets/exercise-gif/nFc4FyV.gif'),
  'nIR4Rwl': require('../../assets/exercise-gif/nIR4Rwl.gif'),
  'nUwVh7b': require('../../assets/exercise-gif/nUwVh7b.gif'),
  'nZZZy9m': require('../../assets/exercise-gif/nZZZy9m.gif'),
  'neonEDL': require('../../assets/exercise-gif/neonEDL.gif'),
  'ngPpyRS': require('../../assets/exercise-gif/ngPpyRS.gif'),
  'niXESDw': require('../../assets/exercise-gif/niXESDw.gif'),
  'ninBEOY': require('../../assets/exercise-gif/ninBEOY.gif'),
  'nlJsbkW': require('../../assets/exercise-gif/nlJsbkW.gif'),
  'nnmCTLN': require('../../assets/exercise-gif/nnmCTLN.gif'),
  'nqs5HGV': require('../../assets/exercise-gif/nqs5HGV.gif'),
  'ns0SIbU': require('../../assets/exercise-gif/ns0SIbU.gif'),
  'ntjtCfu': require('../../assets/exercise-gif/ntjtCfu.gif'),
  'nuBF9MO': require('../../assets/exercise-gif/nuBF9MO.gif'),
  'numr601': require('../../assets/exercise-gif/numr601.gif'),
  'nxW6BkN': require('../../assets/exercise-gif/nxW6BkN.gif'),
  'o17Jfkt': require('../../assets/exercise-gif/o17Jfkt.gif'),
  'o1HGDSq': require('../../assets/exercise-gif/o1HGDSq.gif'),
  'o1ntciW': require('../../assets/exercise-gif/o1ntciW.gif'),
  'o5Jsk92': require('../../assets/exercise-gif/o5Jsk92.gif'),
  'o6LqKKP': require('../../assets/exercise-gif/o6LqKKP.gif'),
  'o80Xu9C': require('../../assets/exercise-gif/o80Xu9C.gif'),
  'o8aOcrz': require('../../assets/exercise-gif/o8aOcrz.gif'),
  'oHg8eop': require('../../assets/exercise-gif/oHg8eop.gif'),
  'oHsrypV': require('../../assets/exercise-gif/oHsrypV.gif'),
  'oLrKqDH': require('../../assets/exercise-gif/oLrKqDH.gif'),
  'oMwyl17': require('../../assets/exercise-gif/oMwyl17.gif'),
  'oMypNrz': require('../../assets/exercise-gif/oMypNrz.gif'),
  'oQRJYkC': require('../../assets/exercise-gif/oQRJYkC.gif'),
  'oR7O9LW': require('../../assets/exercise-gif/oR7O9LW.gif'),
  'oROuvrX': require('../../assets/exercise-gif/oROuvrX.gif'),
  'oZjMu1t': require('../../assets/exercise-gif/oZjMu1t.gif'),
  'obe5LMq': require('../../assets/exercise-gif/obe5LMq.gif'),
  'ocYc6Db': require('../../assets/exercise-gif/ocYc6Db.gif'),
  'omsF3RN': require('../../assets/exercise-gif/omsF3RN.gif'),
  'ookVu2D': require('../../assets/exercise-gif/ookVu2D.gif'),
  'oom75KC': require('../../assets/exercise-gif/oom75KC.gif'),
  'osdXT3K': require('../../assets/exercise-gif/osdXT3K.gif'),
  'otqIxU4': require('../../assets/exercise-gif/otqIxU4.gif'),
  'p0OCXGb': require('../../assets/exercise-gif/p0OCXGb.gif'),
  'p195zsJ': require('../../assets/exercise-gif/p195zsJ.gif'),
  'p5v6rdT': require('../../assets/exercise-gif/p5v6rdT.gif'),
  'p9cCe2r': require('../../assets/exercise-gif/p9cCe2r.gif'),
  'pAIWRGu': require('../../assets/exercise-gif/pAIWRGu.gif'),
  'pFuK3by': require('../../assets/exercise-gif/pFuK3by.gif'),
  'pH2x2jj': require('../../assets/exercise-gif/pH2x2jj.gif'),
  'pM07UxU': require('../../assets/exercise-gif/pM07UxU.gif'),
  'pNIKolI': require('../../assets/exercise-gif/pNIKolI.gif'),
  'pP8wP2P': require('../../assets/exercise-gif/pP8wP2P.gif'),
  'pQ0Mx1Z': require('../../assets/exercise-gif/pQ0Mx1Z.gif'),
  'pX9Elbe': require('../../assets/exercise-gif/pX9Elbe.gif'),
  'pZwUsKB': require('../../assets/exercise-gif/pZwUsKB.gif'),
  'peAeMR3': require('../../assets/exercise-gif/peAeMR3.gif'),
  'pgIdT6i': require('../../assets/exercise-gif/pgIdT6i.gif'),
  'pj0X0tF': require('../../assets/exercise-gif/pj0X0tF.gif'),
  'pkSoCW9': require('../../assets/exercise-gif/pkSoCW9.gif'),
  'pmnrOp0': require('../../assets/exercise-gif/pmnrOp0.gif'),
  'prbWx1D': require('../../assets/exercise-gif/prbWx1D.gif'),
  'pvBMLHA': require('../../assets/exercise-gif/pvBMLHA.gif'),
  'pwt0pnM': require('../../assets/exercise-gif/pwt0pnM.gif'),
  'py1HSzx': require('../../assets/exercise-gif/py1HSzx.gif'),
  'q2ADGqV': require('../../assets/exercise-gif/q2ADGqV.gif'),
  'q6y3OhV': require('../../assets/exercise-gif/q6y3OhV.gif'),
  'q7qkONO': require('../../assets/exercise-gif/q7qkONO.gif'),
  'q8aHNoF': require('../../assets/exercise-gif/q8aHNoF.gif'),
  'qAmNMJY': require('../../assets/exercise-gif/qAmNMJY.gif'),
  'qBcKorM': require('../../assets/exercise-gif/qBcKorM.gif'),
  'qBl14UC': require('../../assets/exercise-gif/qBl14UC.gif'),
  'qCNVnaU': require('../../assets/exercise-gif/qCNVnaU.gif'),
  'qDnGfDb': require('../../assets/exercise-gif/qDnGfDb.gif'),
  'qEse6fe': require('../../assets/exercise-gif/qEse6fe.gif'),
  'qFHvMnv': require('../../assets/exercise-gif/qFHvMnv.gif'),
  'qFpAkpP': require('../../assets/exercise-gif/qFpAkpP.gif'),
  'qKBpF7I': require('../../assets/exercise-gif/qKBpF7I.gif'),
  'qLpO4vV': require('../../assets/exercise-gif/qLpO4vV.gif'),
  'qOKcgVP': require('../../assets/exercise-gif/qOKcgVP.gif'),
  'qOgPVf6': require('../../assets/exercise-gif/qOgPVf6.gif'),
  'qPEzJjA': require('../../assets/exercise-gif/qPEzJjA.gif'),
  'qRZ5S1N': require('../../assets/exercise-gif/qRZ5S1N.gif'),
  'qU8bYp7': require('../../assets/exercise-gif/qU8bYp7.gif'),
  'qXTaZnJ': require('../../assets/exercise-gif/qXTaZnJ.gif'),
  'qaZVsGk': require('../../assets/exercise-gif/qaZVsGk.gif'),
  'qatbkEd': require('../../assets/exercise-gif/qatbkEd.gif'),
  'qcNN2FN': require('../../assets/exercise-gif/qcNN2FN.gif'),
  'qcY50ZD': require('../../assets/exercise-gif/qcY50ZD.gif'),
  'qdRxqCj': require('../../assets/exercise-gif/qdRxqCj.gif'),
  'qg2PGl6': require('../../assets/exercise-gif/qg2PGl6.gif'),
  'qi996YS': require('../../assets/exercise-gif/qi996YS.gif'),
  'qlZUaZ8': require('../../assets/exercise-gif/qlZUaZ8.gif'),
  'qm9veZw': require('../../assets/exercise-gif/qm9veZw.gif'),
  'qx4fgX7': require('../../assets/exercise-gif/qx4fgX7.gif'),
  'r0z6xzQ': require('../../assets/exercise-gif/r0z6xzQ.gif'),
  'r1XNRYB': require('../../assets/exercise-gif/r1XNRYB.gif'),
  'r29jP7S': require('../../assets/exercise-gif/r29jP7S.gif'),
  'r4RZKpF': require('../../assets/exercise-gif/r4RZKpF.gif'),
  'r5DgrW9': require('../../assets/exercise-gif/r5DgrW9.gif'),
  'r7cT9YD': require('../../assets/exercise-gif/r7cT9YD.gif'),
  'rDAiRf9': require('../../assets/exercise-gif/rDAiRf9.gif'),
  'rEhi2o5': require('../../assets/exercise-gif/rEhi2o5.gif'),
  'rGwhJ5o': require('../../assets/exercise-gif/rGwhJ5o.gif'),
  'rQhGcin': require('../../assets/exercise-gif/rQhGcin.gif'),
  'rQxwMxO': require('../../assets/exercise-gif/rQxwMxO.gif'),
  'rR0LJzx': require('../../assets/exercise-gif/rR0LJzx.gif'),
  'rTbyBYV': require('../../assets/exercise-gif/rTbyBYV.gif'),
  'rUXfn3R': require('../../assets/exercise-gif/rUXfn3R.gif'),
  'rWoBmi5': require('../../assets/exercise-gif/rWoBmi5.gif'),
  'rZ80Gbp': require('../../assets/exercise-gif/rZ80Gbp.gif'),
  'rbu5UUb': require('../../assets/exercise-gif/rbu5UUb.gif'),
  'reFHapa': require('../../assets/exercise-gif/reFHapa.gif'),
  'rg59QCH': require('../../assets/exercise-gif/rg59QCH.gif'),
  'rjiM4L3': require('../../assets/exercise-gif/rjiM4L3.gif'),
  'rjtuP6X': require('../../assets/exercise-gif/rjtuP6X.gif'),
  'rkg41Fb': require('../../assets/exercise-gif/rkg41Fb.gif'),
  'rmEukuS': require('../../assets/exercise-gif/rmEukuS.gif'),
  'rseLfH3': require('../../assets/exercise-gif/rseLfH3.gif'),
  's0HKO2I': require('../../assets/exercise-gif/s0HKO2I.gif'),
  's34Y4LR': require('../../assets/exercise-gif/s34Y4LR.gif'),
  's5PdDyY': require('../../assets/exercise-gif/s5PdDyY.gif'),
  's7HX1BY': require('../../assets/exercise-gif/s7HX1BY.gif'),
  's8nrDXF': require('../../assets/exercise-gif/s8nrDXF.gif'),
  's999Hdo': require('../../assets/exercise-gif/s999Hdo.gif'),
  'sJElUUI': require('../../assets/exercise-gif/sJElUUI.gif'),
  'sJFIDIp': require('../../assets/exercise-gif/sJFIDIp.gif'),
  'sM84pE4': require('../../assets/exercise-gif/sM84pE4.gif'),
  'sTfvVsG': require('../../assets/exercise-gif/sTfvVsG.gif'),
  'sTg7iys': require('../../assets/exercise-gif/sTg7iys.gif'),
  'sU5BrfP': require('../../assets/exercise-gif/sU5BrfP.gif'),
  'sVQCCeG': require('../../assets/exercise-gif/sVQCCeG.gif'),
  'sVvXT5J': require('../../assets/exercise-gif/sVvXT5J.gif'),
  'sYCcnon': require('../../assets/exercise-gif/sYCcnon.gif'),
  'sZOR9EV': require('../../assets/exercise-gif/sZOR9EV.gif'),
  'slDvUAU': require('../../assets/exercise-gif/slDvUAU.gif'),
  'soIB2rj': require('../../assets/exercise-gif/soIB2rj.gif'),
  'sxY5Biu': require('../../assets/exercise-gif/sxY5Biu.gif'),
  'syUwUKY': require('../../assets/exercise-gif/syUwUKY.gif'),
  'szIn2UK': require('../../assets/exercise-gif/szIn2UK.gif'),
  't8iSghb': require('../../assets/exercise-gif/t8iSghb.gif'),
  'tBWXbIT': require('../../assets/exercise-gif/tBWXbIT.gif'),
  'tFGKm99': require('../../assets/exercise-gif/tFGKm99.gif'),
  'tFToB7l': require('../../assets/exercise-gif/tFToB7l.gif'),
  'tJ5nYqo': require('../../assets/exercise-gif/tJ5nYqo.gif'),
  'tTuZSDT': require('../../assets/exercise-gif/tTuZSDT.gif'),
  'tZkGYZ9': require('../../assets/exercise-gif/tZkGYZ9.gif'),
  'tc5dYrf': require('../../assets/exercise-gif/tc5dYrf.gif'),
  'tgryw5Y': require('../../assets/exercise-gif/tgryw5Y.gif'),
  'tig3PXb': require('../../assets/exercise-gif/tig3PXb.gif'),
  'tj41Nu6': require('../../assets/exercise-gif/tj41Nu6.gif'),
  'tnaj0mT': require('../../assets/exercise-gif/tnaj0mT.gif'),
  'trmte8s': require('../../assets/exercise-gif/trmte8s.gif'),
  'trqKQv2': require('../../assets/exercise-gif/trqKQv2.gif'),
  'tuIZFDt': require('../../assets/exercise-gif/tuIZFDt.gif'),
  'tznL2Ad': require('../../assets/exercise-gif/tznL2Ad.gif'),
  'u0cNiij': require('../../assets/exercise-gif/u0cNiij.gif'),
  'u0pLNgz': require('../../assets/exercise-gif/u0pLNgz.gif'),
  'u1iHcoD': require('../../assets/exercise-gif/u1iHcoD.gif'),
  'u27Kcdz': require('../../assets/exercise-gif/u27Kcdz.gif'),
  'u2X71Np': require('../../assets/exercise-gif/u2X71Np.gif'),
  'u3UuCZu': require('../../assets/exercise-gif/u3UuCZu.gif'),
  'u4bAmKp': require('../../assets/exercise-gif/u4bAmKp.gif'),
  'u5ESqzH': require('../../assets/exercise-gif/u5ESqzH.gif'),
  'uJmK7Z1': require('../../assets/exercise-gif/uJmK7Z1.gif'),
  'uKyN64F': require('../../assets/exercise-gif/uKyN64F.gif'),
  'uL9CsKm': require('../../assets/exercise-gif/uL9CsKm.gif'),
  'uOV3Itw': require('../../assets/exercise-gif/uOV3Itw.gif'),
  'uSkDMYl': require('../../assets/exercise-gif/uSkDMYl.gif'),
  'uTBt1HV': require('../../assets/exercise-gif/uTBt1HV.gif'),
  'uTv34oq': require('../../assets/exercise-gif/uTv34oq.gif'),
  'uWpxD4v': require('../../assets/exercise-gif/uWpxD4v.gif'),
  'uX3sUBz': require('../../assets/exercise-gif/uX3sUBz.gif'),
  'uZKq7lo': require('../../assets/exercise-gif/uZKq7lo.gif'),
  'ufaxB52': require('../../assets/exercise-gif/ufaxB52.gif'),
  'uxJcFUU': require('../../assets/exercise-gif/uxJcFUU.gif'),
  'v1qBec9': require('../../assets/exercise-gif/v1qBec9.gif'),
  'v2DfH14': require('../../assets/exercise-gif/v2DfH14.gif'),
  'v3vLFW0': require('../../assets/exercise-gif/v3vLFW0.gif'),
  'v3xmPAR': require('../../assets/exercise-gif/v3xmPAR.gif'),
  'v6EKk0O': require('../../assets/exercise-gif/v6EKk0O.gif'),
  'v7p5bYl': require('../../assets/exercise-gif/v7p5bYl.gif'),
  'vAwm6rK': require('../../assets/exercise-gif/vAwm6rK.gif'),
  'vBNyir7': require('../../assets/exercise-gif/vBNyir7.gif'),
  'vIICElP': require('../../assets/exercise-gif/vIICElP.gif'),
  'vKilzz3': require('../../assets/exercise-gif/vKilzz3.gif'),
  'vM5YS2g': require('../../assets/exercise-gif/vM5YS2g.gif'),
  'vN5HB0s': require('../../assets/exercise-gif/vN5HB0s.gif'),
  'vNPJbDA': require('../../assets/exercise-gif/vNPJbDA.gif'),
  'vR1vold': require('../../assets/exercise-gif/vR1vold.gif'),
  'vUTfFHw': require('../../assets/exercise-gif/vUTfFHw.gif'),
  'vYk8lqw': require('../../assets/exercise-gif/vYk8lqw.gif'),
  'veXwo0D': require('../../assets/exercise-gif/veXwo0D.gif'),
  'vi8EhoE': require('../../assets/exercise-gif/vi8EhoE.gif'),
  'vmwLyCg': require('../../assets/exercise-gif/vmwLyCg.gif'),
  'vobtVkm': require('../../assets/exercise-gif/vobtVkm.gif'),
  'vocve3e': require('../../assets/exercise-gif/vocve3e.gif'),
  'vpQaQkH': require('../../assets/exercise-gif/vpQaQkH.gif'),
  'vpleANJ': require('../../assets/exercise-gif/vpleANJ.gif'),
  'vpp9Ku2': require('../../assets/exercise-gif/vpp9Ku2.gif'),
  'vptOQ4N': require('../../assets/exercise-gif/vptOQ4N.gif'),
  'vqsbmL0': require('../../assets/exercise-gif/vqsbmL0.gif'),
  'vrhHa6D': require('../../assets/exercise-gif/vrhHa6D.gif'),
  'vsMcDi9': require('../../assets/exercise-gif/vsMcDi9.gif'),
  'vsVoPHt': require('../../assets/exercise-gif/vsVoPHt.gif'),
  'vtusOWT': require('../../assets/exercise-gif/vtusOWT.gif'),
  'vvNjDJS': require('../../assets/exercise-gif/vvNjDJS.gif'),
  'vzAxBtt': require('../../assets/exercise-gif/vzAxBtt.gif'),
  'w1NOByi': require('../../assets/exercise-gif/w1NOByi.gif'),
  'w2oRpuH': require('../../assets/exercise-gif/w2oRpuH.gif'),
  'w44vFvP': require('../../assets/exercise-gif/w44vFvP.gif'),
  'w4dLzSx': require('../../assets/exercise-gif/w4dLzSx.gif'),
  'w7obpWd': require('../../assets/exercise-gif/w7obpWd.gif'),
  'wDN97Ca': require('../../assets/exercise-gif/wDN97Ca.gif'),
  'wDUqY2u': require('../../assets/exercise-gif/wDUqY2u.gif'),
  'wEulIzp': require('../../assets/exercise-gif/wEulIzp.gif'),
  'wOLmCXc': require('../../assets/exercise-gif/wOLmCXc.gif'),
  'wPypxFY': require('../../assets/exercise-gif/wPypxFY.gif'),
  'wQ2c4XD': require('../../assets/exercise-gif/wQ2c4XD.gif'),
  'wSScovH': require('../../assets/exercise-gif/wSScovH.gif'),
  'wVompEp': require('../../assets/exercise-gif/wVompEp.gif'),
  'wWFspEi': require('../../assets/exercise-gif/wWFspEi.gif'),
  'wXvUZC8': require('../../assets/exercise-gif/wXvUZC8.gif'),
  'wbUYILZ': require('../../assets/exercise-gif/wbUYILZ.gif'),
  'wd4ds3s': require('../../assets/exercise-gif/wd4ds3s.gif'),
  'wdRZISl': require('../../assets/exercise-gif/wdRZISl.gif'),
  'weoDEpH': require('../../assets/exercise-gif/weoDEpH.gif'),
  'wf24o8S': require('../../assets/exercise-gif/wf24o8S.gif'),
  'wfotm7S': require('../../assets/exercise-gif/wfotm7S.gif'),
  'wi2H9QX': require('../../assets/exercise-gif/wi2H9QX.gif'),
  'wigSg76': require('../../assets/exercise-gif/wigSg76.gif'),
  'wkgnGfb': require('../../assets/exercise-gif/wkgnGfb.gif'),
  'wnEscH8': require('../../assets/exercise-gif/wnEscH8.gif'),
  'woLo1QN': require('../../assets/exercise-gif/woLo1QN.gif'),
  'wpbD28t': require('../../assets/exercise-gif/wpbD28t.gif'),
  'wqNPGCg': require('../../assets/exercise-gif/wqNPGCg.gif'),
  'wt6rwjk': require('../../assets/exercise-gif/wt6rwjk.gif'),
  'wu5LXwz': require('../../assets/exercise-gif/wu5LXwz.gif'),
  'wyaqzOS': require('../../assets/exercise-gif/wyaqzOS.gif'),
  'x0lwvfq': require('../../assets/exercise-gif/x0lwvfq.gif'),
  'x2chWLO': require('../../assets/exercise-gif/x2chWLO.gif'),
  'x306lCW': require('../../assets/exercise-gif/x306lCW.gif'),
  'x69MAlq': require('../../assets/exercise-gif/x69MAlq.gif'),
  'x6KpKpq': require('../../assets/exercise-gif/x6KpKpq.gif'),
  'x825CZm': require('../../assets/exercise-gif/x825CZm.gif'),
  'xAySMB0': require('../../assets/exercise-gif/xAySMB0.gif'),
  'xBYcQHj': require('../../assets/exercise-gif/xBYcQHj.gif'),
  'xDh0lJr': require('../../assets/exercise-gif/xDh0lJr.gif'),
  'xGgAGPm': require('../../assets/exercise-gif/xGgAGPm.gif'),
  'xHKN2s8': require('../../assets/exercise-gif/xHKN2s8.gif'),
  'xLYSdtg': require('../../assets/exercise-gif/xLYSdtg.gif'),
  'xMjBKwn': require('../../assets/exercise-gif/xMjBKwn.gif'),
  'xNrS20v': require('../../assets/exercise-gif/xNrS20v.gif'),
  'xOXZJRZ': require('../../assets/exercise-gif/xOXZJRZ.gif'),
  'xTjr103': require('../../assets/exercise-gif/xTjr103.gif'),
  'xUwnBMT': require('../../assets/exercise-gif/xUwnBMT.gif'),
  'xXm4nYq': require('../../assets/exercise-gif/xXm4nYq.gif'),
  'xbkPfaw': require('../../assets/exercise-gif/xbkPfaw.gif'),
  'xcLntTC': require('../../assets/exercise-gif/xcLntTC.gif'),
  'xdYPUtE': require('../../assets/exercise-gif/xdYPUtE.gif'),
  'xgsGFVM': require('../../assets/exercise-gif/xgsGFVM.gif'),
  'xi0yckC': require('../../assets/exercise-gif/xi0yckC.gif'),
  'xiA6lRr': require('../../assets/exercise-gif/xiA6lRr.gif'),
  'xiHiJcA': require('../../assets/exercise-gif/xiHiJcA.gif'),
  'xifhB5W': require('../../assets/exercise-gif/xifhB5W.gif'),
  'xmM75XG': require('../../assets/exercise-gif/xmM75XG.gif'),
  'xmWQIlT': require('../../assets/exercise-gif/xmWQIlT.gif'),
  'xnInPfE': require('../../assets/exercise-gif/xnInPfE.gif'),
  'xo6sENf': require('../../assets/exercise-gif/xo6sENf.gif'),
  'y5U5B9Y': require('../../assets/exercise-gif/y5U5B9Y.gif'),
  'y5p0H8a': require('../../assets/exercise-gif/y5p0H8a.gif'),
  'y8bYM8w': require('../../assets/exercise-gif/y8bYM8w.gif'),
  'yB9SvIF': require('../../assets/exercise-gif/yB9SvIF.gif'),
  'yCvYdi7': require('../../assets/exercise-gif/yCvYdi7.gif'),
  'yJUHKTn': require('../../assets/exercise-gif/yJUHKTn.gif'),
  'yQe5HpE': require('../../assets/exercise-gif/yQe5HpE.gif'),
  'yRLPCLu': require('../../assets/exercise-gif/yRLPCLu.gif'),
  'yRYyfdA': require('../../assets/exercise-gif/yRYyfdA.gif'),
  'yRpV5TC': require('../../assets/exercise-gif/yRpV5TC.gif'),
  'yT9tk17': require('../../assets/exercise-gif/yT9tk17.gif'),
  'yU7w7CA': require('../../assets/exercise-gif/yU7w7CA.gif'),
  'yUdIGNs': require('../../assets/exercise-gif/yUdIGNs.gif'),
  'yWxMvB5': require('../../assets/exercise-gif/yWxMvB5.gif'),
  'yaAxcQr': require('../../assets/exercise-gif/yaAxcQr.gif'),
  'yaMIo4D': require('../../assets/exercise-gif/yaMIo4D.gif'),
  'ye84CTU': require('../../assets/exercise-gif/ye84CTU.gif'),
  'yg8Totb': require('../../assets/exercise-gif/yg8Totb.gif'),
  'ykA5tU7': require('../../assets/exercise-gif/ykA5tU7.gif'),
  'ykHcWme': require('../../assets/exercise-gif/ykHcWme.gif'),
  'ykUOVze': require('../../assets/exercise-gif/ykUOVze.gif'),
  'yl2IYyy': require('../../assets/exercise-gif/yl2IYyy.gif'),
  'yn0LjwL': require('../../assets/exercise-gif/yn0LjwL.gif'),
  'yn2lLSI': require('../../assets/exercise-gif/yn2lLSI.gif'),
  'yn8yg1r': require('../../assets/exercise-gif/yn8yg1r.gif'),
  'yq3GAJX': require('../../assets/exercise-gif/yq3GAJX.gif'),
  'ywaNfuh': require('../../assets/exercise-gif/ywaNfuh.gif'),
  'yz9nUhF': require('../../assets/exercise-gif/yz9nUhF.gif'),
  'yzYH9pI': require('../../assets/exercise-gif/yzYH9pI.gif'),
  'z6TAHoT': require('../../assets/exercise-gif/z6TAHoT.gif'),
  'zCgxPbV': require('../../assets/exercise-gif/zCgxPbV.gif'),
  'zFzbBfL': require('../../assets/exercise-gif/zFzbBfL.gif'),
  'zG0zs85': require('../../assets/exercise-gif/zG0zs85.gif'),
  'zGSIWQi': require('../../assets/exercise-gif/zGSIWQi.gif'),
  'zHEpuuc': require('../../assets/exercise-gif/zHEpuuc.gif'),
  'zILLZ98': require('../../assets/exercise-gif/zILLZ98.gif'),
  'zK8Fu1W': require('../../assets/exercise-gif/zK8Fu1W.gif'),
  'zYmNaoY': require('../../assets/exercise-gif/zYmNaoY.gif'),
  'zZlORz6': require('../../assets/exercise-gif/zZlORz6.gif'),
  'za9Ni4z': require('../../assets/exercise-gif/za9Ni4z.gif'),
  'zd4P4B2': require('../../assets/exercise-gif/zd4P4B2.gif'),
  'zfNHMN9': require('../../assets/exercise-gif/zfNHMN9.gif'),
  'zhF9lW4': require('../../assets/exercise-gif/zhF9lW4.gif'),
  'zhMwOwE': require('../../assets/exercise-gif/zhMwOwE.gif'),
  'ziFKQXP': require('../../assets/exercise-gif/ziFKQXP.gif'),
  'zkgRrbK': require('../../assets/exercise-gif/zkgRrbK.gif'),
  'znLogoF': require('../../assets/exercise-gif/znLogoF.gif'),
  'znP9SIh': require('../../assets/exercise-gif/znP9SIh.gif'),
  'znQUdHY': require('../../assets/exercise-gif/znQUdHY.gif'),
  'znf7t8E': require('../../assets/exercise-gif/znf7t8E.gif'),
  'zoOvPcx': require('../../assets/exercise-gif/zoOvPcx.gif'),
  'ztAa1RK': require('../../assets/exercise-gif/ztAa1RK.gif'),
};

/**
 * Get bundled image for exercise ID
 */
export const getExerciseImage = (exerciseId: string): any => {
  return exerciseImages[exerciseId] || null;
};

/**
 * Check if exercise has bundled image
 */
export const hasExerciseImage = (exerciseId: string): boolean => {
  return exerciseId in exerciseImages;
};

/**
 * Get all available exercise IDs
 */
export const getAvailableExerciseIds = (): string[] => {
  return Object.keys(exerciseImages);
};

/**
 * Get total number of available images
 */
export const getImageCount = (): number => {
  return Object.keys(exerciseImages).length;
};

export default exerciseImages;